import { useState, useEffect } from "react";
import { createClient } from "@supabase/supabase-js";

const SUPABASE_URL = process.env.REACT_APP_SUPABASE_URL;
const SUPABASE_KEY = process.env.REACT_APP_SUPABASE_KEY;
const ADMIN_EMAIL  = "sanketworks20@gmail.com";
const WA_NUMBER    = "917984177249";

const supabase = createClient(SUPABASE_URL, SUPABASE_KEY, {
  auth: {
    persistSession: true,
    storage: window.localStorage,
    autoRefreshToken: true,
    detectSessionInUrl: true,
  },
});
// ── Design Tokens ─────────────────────────────────────────────────────────
const T = {
  bg:"#0A0A0B", surface:"#111113", surfaceEl:"#18181B",
  border:"#27272A", borderHi:"#3F3F46",
  gold:"#C8960C", goldLight:"#E8B830", goldDim:"#7A5C08",
  text:"#FAFAF9", textSub:"#A1A1AA", textMuted:"#52525B",
  green:"#22C55E", red:"#EF4444", amber:"#F59E0B", blue:"#3B82F6",
};

// ── Inject CSS ─────────────────────────────────────────────────────────────
const injectCSS = () => {
  if (document.getElementById("cn-styles")) return;
  const s = document.createElement("style");
  s.id = "cn-styles";
  s.innerHTML = `
    @import url('https://fonts.googleapis.com/css2?family=Instrument+Serif:ital@0;1&family=Cabinet+Grotesk:wght@300;400;500;600;700;800&family=JetBrains+Mono:wght@400;500&display=swap');
    *,*::before,*::after{box-sizing:border-box;margin:0;padding:0;}
    html{scroll-behavior:smooth;}
    body{background:${T.bg};color:${T.text};font-family:'Cabinet Grotesk',sans-serif;font-size:15px;line-height:1.6;-webkit-font-smoothing:antialiased;overflow-x:hidden;-webkit-text-size-adjust:100%;}
input,textarea,select{font-size:16px!important;}
    ::selection{background:${T.goldDim}44;color:${T.text};}
    ::-webkit-scrollbar{width:5px;}::-webkit-scrollbar-track{background:${T.bg};}::-webkit-scrollbar-thumb{background:${T.border};border-radius:3px;}
    @keyframes fadeUp{from{opacity:0;transform:translateY(20px)}to{opacity:1;transform:none}}
    @keyframes fadeIn{from{opacity:0}to{opacity:1}}
    @keyframes shimmer{0%{background-position:-200% center}100%{background-position:200% center}}
    @keyframes pulse{0%,100%{opacity:1}50%{opacity:.4}}
    @keyframes spin{to{transform:rotate(360deg)}}
    @keyframes toastIn{from{opacity:0;transform:translateY(8px)}to{opacity:1;transform:none}}
    @keyframes modalIn{from{opacity:0;transform:scale(.97)}to{opacity:1;transform:scale(1)}}
    .fade-up{animation:fadeUp .5s cubic-bezier(.16,1,.3,1) forwards;}
    .fade-in{animation:fadeIn .35s ease forwards;}
    .btn-primary{display:inline-flex;align-items:center;gap:8px;background:linear-gradient(135deg,${T.gold} 0%,${T.goldLight} 50%,${T.gold} 100%);background-size:200% auto;color:#0A0A0B;font-family:'Cabinet Grotesk',sans-serif;font-weight:700;font-size:14px;padding:11px 22px;border-radius:10px;border:none;cursor:pointer;transition:all .25s;box-shadow:0 2px 16px rgba(200,150,12,.2);white-space:nowrap;}
    .btn-primary:hover{background-position:right center;box-shadow:0 6px 24px rgba(200,150,12,.35);transform:translateY(-1px);}
    .btn-primary:active{transform:translateY(0);}
    .btn-primary:disabled{opacity:.5;cursor:not-allowed;transform:none;}
    .btn-ghost{display:inline-flex;align-items:center;gap:7px;background:transparent;color:${T.textSub};font-family:'Cabinet Grotesk',sans-serif;font-weight:500;font-size:13px;padding:10px 16px;border-radius:9px;border:1px solid ${T.border};cursor:pointer;transition:all .2s;white-space:nowrap;}
    .btn-ghost:hover{border-color:${T.borderHi};color:${T.text};background:${T.surfaceEl};}
    .btn-danger{display:inline-flex;align-items:center;gap:7px;background:rgba(239,68,68,.08);color:${T.red};font-family:'Cabinet Grotesk',sans-serif;font-weight:500;font-size:13px;padding:10px 16px;border-radius:9px;border:1px solid rgba(239,68,68,.2);cursor:pointer;transition:all .2s;}
    .btn-danger:hover{background:rgba(239,68,68,.15);}
    .card{background:${T.surface};border:1px solid ${T.border};border-radius:14px;padding:24px;}
    .card-hover{transition:border-color .2s,transform .2s,box-shadow .2s;}
    .card-hover:hover{border-color:${T.borderHi};transform:translateY(-2px);box-shadow:0 12px 40px rgba(0,0,0,.5);}
    .input-field{width:100%;background:${T.surfaceEl};border:1.5px solid ${T.border};border-radius:9px;color:${T.text};font-family:'Cabinet Grotesk',sans-serif;font-size:14px;padding:11px 14px;outline:none;transition:border-color .2s,box-shadow .2s;}
    .input-field:focus{border-color:${T.gold};box-shadow:0 0 0 3px rgba(200,150,12,.1);}
    .input-field::placeholder{color:${T.textMuted};}
    select.input-field{appearance:none;cursor:pointer;}
    textarea.input-field{resize:vertical;}
    .label{font-size:11px;font-weight:700;color:${T.textSub};letter-spacing:.6px;text-transform:uppercase;margin-bottom:7px;display:block;}
    .badge{display:inline-flex;align-items:center;gap:4px;padding:3px 9px;border-radius:20px;font-size:10px;font-weight:700;letter-spacing:.4px;text-transform:uppercase;}
    .badge-green{background:rgba(34,197,94,.1);color:${T.green};border:1px solid rgba(34,197,94,.2);}
    .badge-amber{background:rgba(245,158,11,.1);color:${T.amber};border:1px solid rgba(245,158,11,.2);}
    .badge-red{background:rgba(239,68,68,.1);color:${T.red};border:1px solid rgba(239,68,68,.2);}
    .badge-gold{background:rgba(200,150,12,.1);color:${T.goldLight};border:1px solid rgba(200,150,12,.2);}
    .badge-blue{background:rgba(59,130,246,.1);color:${T.blue};border:1px solid rgba(59,130,246,.2);}
    .mono{font-family:'JetBrains Mono',monospace;}
    .nav-item{width:100%;display:flex;align-items:center;gap:10px;padding:10px 12px;border-radius:9px;border:none;cursor:pointer;margin-bottom:2px;transition:all .15s;font-family:'Cabinet Grotesk',sans-serif;font-size:13px;font-weight:500;background:transparent;color:${T.textSub};text-align:left;}
    .nav-item:hover{background:${T.surfaceEl};color:${T.text};}
    .nav-item.active{background:rgba(200,150,12,.1);color:${T.goldLight};font-weight:700;}
    .table-row{transition:background .15s;border-radius:8px;}
    .table-row:hover{background:${T.surfaceEl};}
    .spinner{width:16px;height:16px;border:2px solid rgba(0,0,0,.15);border-top-color:#0A0A0B;border-radius:50%;animation:spin .7s linear infinite;display:inline-block;flex-shrink:0;}
    .spinner-gold{width:24px;height:24px;border:2px solid rgba(200,150,12,.2);border-top-color:${T.goldLight};border-radius:50%;animation:spin .7s linear infinite;}
    .toggle-switch{position:relative;width:48px;height:26px;flex-shrink:0;}
    .toggle-switch input{opacity:0;width:0;height:0;}
    .toggle-slider{position:absolute;cursor:pointer;top:0;left:0;right:0;bottom:0;background:${T.border};border-radius:26px;transition:.3s;}
    .toggle-slider:before{position:absolute;content:"";height:20px;width:20px;left:3px;bottom:3px;background:white;border-radius:50%;transition:.3s;}
    input:checked+.toggle-slider{background:${T.gold};}
    input:checked+.toggle-slider:before{transform:translateX(22px);}
    @media(max-width:768px){
      .sidebar{transform:translateX(-100%);transition:transform .3s;position:fixed!important;z-index:200!important;}
      .sidebar.open{transform:translateX(0);}
      .main-content{margin-left:0!important;padding:16px!important;}
      .stats-grid{grid-template-columns:repeat(2,1fr)!important;}
      .features-grid{grid-template-columns:1fr!important;}
      .testimonials-grid{grid-template-columns:1fr!important;}
      .steps-grid{grid-template-columns:1fr!important;}
      .pricing-grid{grid-template-columns:1fr!important;}
      .roadmap-grid{grid-template-columns:1fr!important;}
      .invoice-table{display:none!important;}
      .invoice-cards{display:flex!important;flex-direction:column;gap:12px;}
      .modal-inner{padding:20px!important;}
      .form-grid{grid-template-columns:1fr!important;}
      .mobile-overlay{display:block;position:fixed;inset:0;background:rgba(0,0,0,.6);z-index:150;}
    }
    @media(min-width:769px){
      .mobile-header{display:none!important;}
      .invoice-cards{display:none!important;}
      .mobile-overlay{display:none;}
    }
  `;
  document.head.appendChild(s);
};

// ── Utils ──────────────────────────────────────────────────────────────────
const fmt = n => new Intl.NumberFormat("en-IN",{style:"currency",currency:"INR",maximumFractionDigits:0}).format(n);
const fmtDate = d => new Date(d).toLocaleDateString("en-IN",{day:"numeric",month:"short",year:"numeric"});
const daysUntil = d => Math.ceil((new Date(d)-new Date())/86400000);
const genInvNum = () => `INV-${new Date().getFullYear()}-${String(Math.floor(Math.random()*9000)+1000)}`;

// ── Send Email via Brevo ───────────────────────────────────────────────────
const sendEmail = async ({to,toName,subject,html,replyTo}) => {
  try {
    const res = await fetch("/api/send-email",{
  method:"POST",
  headers:{"Content-Type":"application/json"},
  body:JSON.stringify({to,toName,subject,html,replyTo}),
});
    return res.ok;
  } catch { return false; }
};

// ── Email Templates ────────────────────────────────────────────────────────
const buildReminderEmail = (inv, senderName, senderPhone, type) => {
  const headers = {
    preDue:   { bg:"linear-gradient(135deg,#C8960C,#E8B830)", title:"Payment Reminder",  color:"#0A0A0B" },
    dueToday: { bg:"linear-gradient(135deg,#F59E0B,#EF4444)", title:"Payment Due Today", color:"#ffffff" },
    overdue:  { bg:"linear-gradient(135deg,#EF4444,#DC2626)", title:"Invoice Overdue",   color:"#ffffff" },
  };
  const subjects = {
    preDue:   `Reminder: Invoice #${inv.invoice_number} due on ${fmtDate(inv.due_date)}`,
    dueToday: `Due Today: Invoice #${inv.invoice_number} — ${fmt(inv.amount)}`,
    overdue:  `Overdue: Invoice #${inv.invoice_number} — Action Required`,
  };
  const h = headers[type];
  const payBtn = inv.payment_link
    ? `<div style="text-align:center;margin:24px 0;">
        <a href="${inv.payment_link}"
           target="_blank"
           style="display:inline-block;background-color:#C8960C;color:#000000;font-family:Arial,sans-serif;font-weight:bold;font-size:16px;padding:14px 32px;border-radius:8px;text-decoration:none;border:2px solid #C8960C;">
           Pay Now &mdash; ${fmt(inv.amount)}
        </a>
        <br/>
        <span style="display:block;margin-top:10px;font-size:12px;color:#A1A1AA;">
          Or copy: <a href="${inv.payment_link}" style="color:#C8960C;word-break:break-all;">${inv.payment_link}</a>
        </span>
      </div>`
    : "";
  const html = `
    <div style="font-family:sans-serif;max-width:580px;margin:0 auto;background:#0A0A0B;color:#FAFAF9;border-radius:16px;overflow:hidden;border:1px solid #27272A;">
      <div style="background:${h.bg};padding:28px 32px;">
        <a href="https://chasenahi.in" style="text-decoration:none;">
          <div style="display:flex;align-items:center;gap:10px;margin-bottom:16px;">
            <div style="width:32px;height:32px;background:rgba(0,0,0,.2);border-radius:8px;display:flex;align-items:center;justify-content:center;">
              <span style="color:${h.color};font-size:16px;font-weight:700;">⚡</span>
            </div>
            <span style="color:${h.color};font-size:16px;font-weight:700;opacity:.9;">ChaseNahi</span>
          </div>
        </a>
        <h1 style="font-size:28px;font-weight:800;color:${h.color};margin:0 0 8px;">${h.title}</h1>
        <p style="color:${h.color};opacity:.8;margin:0;font-size:15px;font-weight:600;">${senderName}</p>
        ${senderPhone ? `<p style="color:${h.color};opacity:.7;margin:4px 0 0;font-size:13px;">📞 ${senderPhone}</p>` : ""}
      </div>
      <div style="padding:32px;">
        <p style="color:#A1A1AA;margin-bottom:20px;font-size:15px;">Hi <strong style="color:#FAFAF9;">${inv.client_name}</strong>,</p>
        <p style="color:#FAFAF9;margin-bottom:28px;line-height:1.7;">
          ${type==="preDue" ? "This is a friendly reminder that your invoice is due soon. Please arrange payment at your earliest convenience." : ""}
          ${type==="dueToday" ? "Your invoice is due today. Please process the payment to keep our work moving forward." : ""}
          ${type==="overdue" ? "This invoice is now overdue. Please process the payment immediately to avoid any disruption." : ""}
        </p>
        <div style="background:#18181B;border:1px solid #27272A;border-radius:12px;overflow:hidden;margin-bottom:24px;">
          <table style="width:100%;border-collapse:collapse;">
            <tr style="border-bottom:1px solid #27272A;">
              <td style="padding:12px 16px;color:#A1A1AA;font-size:13px;width:40%;">Invoice Number</td>
              <td style="padding:12px 16px;color:#FAFAF9;font-weight:600;font-size:13px;">#${inv.invoice_number}</td>
            </tr>
            <tr style="border-bottom:1px solid #27272A;">
              <td style="padding:12px 16px;color:#A1A1AA;font-size:13px;">Project</td>
              <td style="padding:12px 16px;color:#FAFAF9;font-size:13px;">${inv.project_name}</td>
            </tr>
            <tr style="border-bottom:1px solid #27272A;">
              <td style="padding:12px 16px;color:#A1A1AA;font-size:13px;">Due Date</td>
              <td style="padding:12px 16px;color:${type==="overdue"?"#EF4444":type==="dueToday"?"#F59E0B":"#E8B830"};font-weight:600;font-size:13px;">${type==="dueToday"?"Today":fmtDate(inv.due_date)}</td>
            </tr>
            <tr>
              <td style="padding:16px;color:#A1A1AA;font-size:13px;">Amount Due</td>
              <td style="padding:16px;color:#E8B830;font-size:22px;font-weight:700;">${fmt(inv.amount)}</td>
            </tr>
          </table>
        </div>
        ${payBtn}
        <div style="border-top:1px solid #27272A;padding-top:20px;margin-top:8px;">
          <p style="color:#52525B;font-size:12px;margin:0;">Sent via <a href="https://chasenahi.in" style="color:#C8960C;text-decoration:none;">ChaseNahi</a> · Automated invoice reminders for Indian freelancers</p>
        </div>
      </div>
    </div>`;
  return { subject: subjects[type], html };
};

const buildPaidEmail = (inv, senderName) => ({
  subject: `Payment Received ✅ — Invoice #${inv.invoice_number}`,
  html: `
    <div style="font-family:sans-serif;max-width:580px;margin:0 auto;background:#0A0A0B;color:#FAFAF9;border-radius:16px;overflow:hidden;border:1px solid #27272A;">
      <div style="background:linear-gradient(135deg,#22C55E,#16A34A);padding:28px 32px;">
        <h1 style="font-size:28px;font-weight:800;color:#fff;margin:0 0 8px;">Payment Received! 🎉</h1>
        <p style="color:rgba(255,255,255,.8);margin:0;font-size:14px;">Thank you from ${senderName}</p>
      </div>
      <div style="padding:32px;">
        <p style="color:#A1A1AA;margin-bottom:20px;">Hi <strong style="color:#FAFAF9;">${inv.client_name}</strong>,</p>
        <p style="color:#FAFAF9;margin-bottom:24px;line-height:1.7;">Thank you! We've received your payment for the following invoice. Your payment has been recorded.</p>
        <div style="background:#18181B;border:1px solid rgba(34,197,94,.2);border-radius:12px;overflow:hidden;margin-bottom:24px;">
          <table style="width:100%;border-collapse:collapse;">
            <tr style="border-bottom:1px solid #27272A;"><td style="padding:12px 16px;color:#A1A1AA;font-size:13px;width:40%;">Invoice</td><td style="padding:12px 16px;color:#FAFAF9;font-weight:600;font-size:13px;">#${inv.invoice_number}</td></tr>
            <tr style="border-bottom:1px solid #27272A;"><td style="padding:12px 16px;color:#A1A1AA;font-size:13px;">Project</td><td style="padding:12px 16px;color:#FAFAF9;font-size:13px;">${inv.project_name}</td></tr>
            <tr><td style="padding:16px;color:#A1A1AA;font-size:13px;">Amount Paid</td><td style="padding:16px;color:#22C55E;font-size:22px;font-weight:700;">${fmt(inv.amount)}</td></tr>
          </table>
        </div>
        <div style="border-top:1px solid #27272A;padding-top:20px;">
          <p style="color:#52525B;font-size:12px;">Sent via <a href="https://chasenahi.in" style="color:#C8960C;text-decoration:none;">ChaseNahi</a></p>
        </div>
      </div>
    </div>`,
});

const buildAdminEmail = (eventType, details) => {
  const titles = { signup:"🆕 New User Signed Up", reminder:"📧 Reminder Sent", paid:"💰 Invoice Marked Paid", invoice_created:"📋 New Invoice Created" };
  const rows = Object.entries(details).map(([k,v])=>`<tr><td style="padding:8px 12px;color:#A1A1AA;font-size:13px;border-bottom:1px solid #27272A;">${k}</td><td style="padding:8px 12px;color:#FAFAF9;font-size:13px;border-bottom:1px solid #27272A;">${v}</td></tr>`).join("");
  return {
    subject: `ChaseNahi Admin: ${titles[eventType]||eventType}`,
    html: `<div style="font-family:sans-serif;max-width:500px;margin:0 auto;background:#0A0A0B;border:1px solid #27272A;border-radius:12px;overflow:hidden;"><div style="background:#18181B;padding:20px 24px;border-bottom:1px solid #27272A;"><h2 style="color:#E8B830;font-size:18px;margin:0;">${titles[eventType]||eventType}</h2><p style="color:#52525B;font-size:12px;margin:4px 0 0;">${new Date().toLocaleString("en-IN")}</p></div><div style="padding:20px 24px;"><table style="width:100%;border-collapse:collapse;">${rows}</table></div><div style="padding:16px 24px;border-top:1px solid #27272A;"><p style="color:#52525B;font-size:11px;margin:0;">ChaseNahi Admin Notification · chasenahi.in</p></div></div>`,
  };
};

// ── Noise ──────────────────────────────────────────────────────────────────
const Noise = () => <div style={{position:"fixed",inset:0,pointerEvents:"none",zIndex:0,opacity:.018,backgroundImage:`url("data:image/svg+xml,%3Csvg viewBox='0 0 256 256' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='.9' numOctaves='4' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23n)'/%3E%3C/svg%3E")`}} />;

// ── Gold Text ──────────────────────────────────────────────────────────────
const Gold = ({children,style={}}) => <span style={{background:`linear-gradient(135deg,${T.gold},${T.goldLight},${T.gold})`,backgroundSize:"200% auto",WebkitBackgroundClip:"text",WebkitTextFillColor:"transparent",backgroundClip:"text",animation:"shimmer 3s linear infinite",...style}}>{children}</span>;

// ── Icon ───────────────────────────────────────────────────────────────────
const Ic = ({n,s=16,c="currentColor"}) => {
  const p = {
    check:<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7"/>,
    arrow:<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3"/>,
    plus:<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4"/>,
    bell:<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9"/>,
    mail:<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"/>,
    rupee:<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 8h6m-5 0a3 3 0 110 6H9l3 6M9 8h2m0 0a3 3 0 110 6"/>,
    clock:<><circle cx={12} cy={12} r={10} strokeWidth={2} stroke="currentColor" fill="none"/><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6v6l4 2"/></>,
    home:<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6"/>,
    chart:<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z"/>,
    logout:<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1"/>,
    x:<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12"/>,
    zap:<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z"/>,
    eye:<><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"/><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"/></>,
    user:<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"/>,
    menu:<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16"/>,
    shield:<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z"/>,
    book:<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253"/>,
    users:<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z"/>,
    phone:<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"/>,
  };
  return <svg width={s} height={s} viewBox="0 0 24 24" fill="none" stroke={c} style={{flexShrink:0}}>{p[n]}</svg>;
};

// ── Toast ──────────────────────────────────────────────────────────────────
const Toast = ({msg,type="success",onClose}) => (
  <div style={{position:"fixed",bottom:24,right:24,zIndex:9999,background:T.surface,border:`1px solid ${T.border}`,borderRadius:12,padding:"14px 18px",boxShadow:"0 20px 60px rgba(0,0,0,.7)",animation:"toastIn .3s ease forwards",display:"flex",alignItems:"center",gap:12,maxWidth:340}}>
    <div style={{width:32,height:32,borderRadius:8,background:type==="success"?"rgba(34,197,94,.1)":"rgba(239,68,68,.1)",display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0}}>
      <Ic n={type==="success"?"check":"x"} s={15} c={type==="success"?T.green:T.red}/>
    </div>
    <span style={{fontSize:13,color:T.text,flex:1}}>{msg}</span>
    <button onClick={onClose} style={{background:"none",border:"none",cursor:"pointer",color:T.textMuted}}><Ic n="x" s={14}/></button>
  </div>
);

// ═══════════════════════════════════════════════════════════════════════════
// LANDING PAGE
// ═══════════════════════════════════════════════════════════════════════════
const Landing = ({onSignup,onLogin,onPrivacy,onTerms}) => {
  const [scrolled,setScrolled] = useState(false);
  const [yearly,setYearly] = useState(false);
  const [blogPost,setBlogPost] = useState(null);

const openBlog = (slug) => {
  window.history.pushState({ page: "landing" }, "", "/");
  setBlogPost(slug);
  window.history.pushState({ blogPost: slug }, "", `/blog/${slug}`);
  window.scrollTo(0, 0);
};

const closeBlog = () => {
  setBlogPost(null);
  window.history.replaceState({ page: "landing" }, "", "/");
  window.scrollTo(0, 0);
};
  useEffect(()=>{
    const h=()=>setScrolled(window.scrollY>40);
    window.addEventListener("scroll",h);
    return ()=>window.removeEventListener("scroll",h);
  },[]);

  const blogs = [
    {
      slug:"follow-up-unpaid-invoices",
      title:"How to Follow Up on Unpaid Invoices Without Losing the Client",
      tag:"Getting Paid",
      mins:"5 min read",
      excerpt:"The awkward silence after sending an invoice is something every Indian freelancer knows. Here's how to follow up professionally without damaging the relationship.",
      content:`
        <h2>The Freelancer's Biggest Problem</h2>
        <p>You've done the work. You've sent the invoice. And now... nothing. Days pass. Then weeks. The client isn't responding and you don't know whether to push or stay quiet.</p>
        <p>This is the most common problem Indian freelancers face — and it costs them lakhs every year in delayed or lost payments.</p>
        <h2>Why Clients Don't Pay On Time</h2>
        <p>Before getting angry at your client, understand why this happens. Most of the time it's not malicious. It's one of three reasons:</p>
        <ul>
          <li><strong>They forgot.</strong> Your invoice is sitting in a folder somewhere and they haven't thought about it.</li>
          <li><strong>They're waiting for approval.</strong> Agencies and companies have payment processes that take time.</li>
          <li><strong>Cash flow issues.</strong> They want to pay but don't have the money right now.</li>
        </ul>
        <h2>The 3-Email System That Works</h2>
        <p><strong>Email 1 — 3 days before due date:</strong> A friendly heads-up. Keep it warm. "Just a reminder that your invoice is due in 3 days. Let me know if you have any questions."</p>
        <p><strong>Email 2 — On the due date:</strong> Clear and direct. "Your invoice is due today. Please process the payment at your earliest convenience."</p>
        <p><strong>Email 3 — 5 days after:</strong> Firm but professional. "Your invoice is now overdue. I'd appreciate payment by [date] to avoid any disruption to our work together."</p>
        <h2>The Golden Rule</h2>
        <p>Never apologise for following up. You did the work. You deserve to be paid. A professional follow-up is not rude — it's expected in any business relationship.</p>
        <p>The easiest way to do this? Let an automated tool handle it for you so you never have to feel awkward again. That's exactly what ChaseNahi does.</p>
      `
    },
    {
      slug:"indian-freelancers-late-payment",
      title:"Why Indian Freelancers Don't Get Paid On Time — And How to Fix It",
      tag:"India Freelancing",
      mins:"4 min read",
      excerpt:"India has 15 million+ freelancers but most struggle with late payments. The problem isn't the clients — it's the system. Here's what actually works.",
      content:`
        <h2>India's Freelancer Payment Problem</h2>
        <p>India is the world's second largest freelance market with over 15 million freelancers. Yet most of them share the same complaint: getting paid on time is a constant struggle.</p>
        <p>The average Indian freelancer waits 45 days to get paid — even when the due date is 15 days. That's a 30-day gap that kills cash flow and causes enormous stress.</p>
        <h2>The Real Reasons</h2>
        <p><strong>1. No follow-up system.</strong> Most freelancers send one invoice and hope for the best. When it's not paid, they feel too awkward to follow up, so they wait. And wait.</p>
        <p><strong>2. Informal work culture.</strong> A lot of Indian freelance work is done through WhatsApp and verbal agreements. Without a formal invoice system, payment terms aren't taken seriously.</p>
        <p><strong>3. No payment link.</strong> Making clients work hard to pay you (bank transfer, finding your UPI, remembering your phone number) means they procrastinate. Add a Pay Now button to your invoices.</p>
        <p><strong>4. Fear of losing the client.</strong> Freelancers worry that a payment follow-up will damage the relationship. In reality, the opposite is true — clients respect freelancers who have clear processes.</p>
        <h2>What Actually Works</h2>
        <p>The freelancers who get paid fastest have one thing in common: a consistent follow-up process. Not a manual one — that takes willpower and emotional energy. An automated one.</p>
        <p>Set up automatic reminders before, on, and after the due date. Add a payment link in every email. And stop apologising for asking to be paid for work you've already done.</p>
      `
    },
    {
      slug:"payment-reminder-email-templates",
      title:"5 Email Templates to Remind Clients About Payment (Without Sounding Rude)",
      tag:"Email Templates",
      mins:"6 min read",
      excerpt:"Copy-paste these 5 proven email templates to follow up on unpaid invoices professionally. Used by 1,200+ Indian freelancers.",
      content:`
        <h2>Why Most Follow-Up Emails Fail</h2>
        <p>Most freelancers either sound too apologetic ("So sorry to bother you...") or too aggressive ("Pay immediately or else..."). Neither works. Here are 5 templates that hit the right tone.</p>
        <h2>Template 1 — Friendly Pre-Due Reminder</h2>
        <p><em>Subject: Quick reminder — Invoice #[NUMBER] due in 3 days</em></p>
        <p>Hi [Client Name],<br/>Just a friendly heads-up that Invoice #[NUMBER] for [PROJECT] is due on [DATE]. The total amount is ₹[AMOUNT].<br/>Let me know if you have any questions. Looking forward to continuing our work together!<br/>Best,<br/>[Your Name]</p>
        <h2>Template 2 — Due Date Reminder</h2>
        <p><em>Subject: Invoice #[NUMBER] is due today</em></p>
        <p>Hi [Client Name],<br/>This is a reminder that Invoice #[NUMBER] for ₹[AMOUNT] is due today. Please process the payment at your earliest convenience.<br/>If you've already paid, please ignore this message.<br/>Thanks,<br/>[Your Name]</p>
        <h2>Template 3 — First Overdue Notice (Professional)</h2>
        <p><em>Subject: Overdue: Invoice #[NUMBER] — Payment Required</em></p>
        <p>Hi [Client Name],<br/>I noticed that Invoice #[NUMBER] for ₹[AMOUNT], due on [DATE], has not yet been settled. I'd appreciate payment by [NEW DATE] to keep our accounts up to date.<br/>Please let me know if there are any issues.<br/>[Your Name]</p>
        <h2>Template 4 — Second Overdue Notice (Firm)</h2>
        <p><em>Subject: Second Notice: Invoice #[NUMBER] — [X] days overdue</em></p>
        <p>Hi [Client Name],<br/>I'm following up again on Invoice #[NUMBER] which is now [X] days overdue. This is affecting my business and I'd appreciate immediate attention to this matter.<br/>Please process payment of ₹[AMOUNT] by [DATE].<br/>[Your Name]</p>
        <h2>Template 5 — Final Notice</h2>
        <p><em>Subject: Final Notice: Invoice #[NUMBER]</em></p>
        <p>Hi [Client Name],<br/>This is a final notice for Invoice #[NUMBER] totalling ₹[AMOUNT], which is now significantly overdue. Please arrange payment immediately.<br/>If I don't receive payment by [DATE], I will need to pause all ongoing work and explore other options.<br/>[Your Name]</p>
        <h2>Automate All of This</h2>
        <p>Instead of writing these manually every time, ChaseNahi sends them automatically on the right days. You focus on the work — we handle getting you paid.</p>
      `
    }
    ,{
  slug:"invoice-followup-email",
  title:"Invoice Follow-Up Email Template for Freelancers in India",
  tag:"Email Templates",
  mins:"5 min read",
  excerpt:"Copy professional invoice follow-up email templates to remind clients without sounding rude or desperate.",
  url:"/blog/invoice-followup-email.html"
},
{
  slug:"client-not-paying",
  title:"Client Not Paying? What Freelancers Should Do in India",
  tag:"Freelancer Guide",
  mins:"5 min read",
  excerpt:"A practical guide for Indian freelancers to follow up, stay professional, and protect cash flow.",
  url:"/blog/client-not-paying.html"
}
  ];

  const roadmap = [
    {
      phase:"Phase 1", status:"live", icon:"✅",
      items:["Auto email reminders (3-stage)","Invoice tracking dashboard","Pay Now button in emails","Manual payment tracking","Free vs Pro plans","WhatsApp support"],
    },
    {
      phase:"Phase 2", status:"soon", icon:"🔨",
      items:["Auto payment detection via Razorpay","WhatsApp automated reminders","Custom email branding","Client payment receipt","Payment analytics"],
      unlock:"Unlocks after 500 community members",
    },
    {
      phase:"Phase 3", status:"future", icon:"🔮",
      items:["Send reminders from your own email","Advanced revenue analytics","Mobile app (Android + iOS)","Team collaboration features","API access for developers","Dedicated account manager"],
    },
  ];

  if (blogPost) {
    const post = blogs.find(b=>b.slug===blogPost);
    return (
      <div style={{minHeight:"100vh",background:T.bg}}>
        <Noise/>
        <nav style={{position:"fixed",top:0,left:0,right:0,zIndex:100,background:"rgba(10,10,11,.92)",backdropFilter:"blur(20px)",borderBottom:`1px solid ${T.border}`}}>
          <div style={{maxWidth:1080,margin:"0 auto",padding:"0 20px",height:60,display:"flex",alignItems:"center",justifyContent:"space-between"}}>
            <button onClick={closeBlog} style={{display:"flex",alignItems:"center",gap:8,background:"none",border:"none",cursor:"pointer",color:T.textSub,fontFamily:"Cabinet Grotesk",fontSize:14}}>
              <Ic n="arrow" s={14} c={T.textSub}/> <span style={{transform:"rotate(180deg)",display:"inline-block"}}>←</span> Back to ChaseNahi
            </button>
            <button className="btn-primary" onClick={onSignup} style={{padding:"8px 16px",fontSize:13}}>Try Free</button>
          </div>
        </nav>
        <div style={{maxWidth:720,margin:"0 auto",padding:"100px 20px 60px"}}>
          <span className="badge badge-gold" style={{marginBottom:16}}>{post.tag}</span>
          <h1 style={{fontFamily:"Instrument Serif",fontSize:"clamp(28px,4vw,44px)",fontWeight:400,lineHeight:1.2,marginBottom:16,marginTop:12}}>{post.title}</h1>
          <p style={{fontSize:13,color:T.textMuted,marginBottom:40}}>{post.mins} · Published by ChaseNahi</p>
          <div style={{color:T.textSub,lineHeight:1.9,fontSize:15}} dangerouslySetInnerHTML={{__html:post.content.replace(/<h2>/g,`<h2 style="font-family:Instrument Serif;font-size:24px;color:${T.text};margin:32px 0 12px;font-weight:400;">`).replace(/<p>/g,`<p style="margin-bottom:16px;">`).replace(/<ul>/g,`<ul style="margin:0 0 16px 20px;">`).replace(/<li>/g,`<li style="margin-bottom:8px;">`).replace(/<strong>/g,`<strong style="color:${T.text};">`)}}/>
          <div style={{background:T.surface,border:`1px solid ${T.border}`,borderRadius:16,padding:"28px",marginTop:48,textAlign:"center"}}>
            <h3 style={{fontFamily:"Instrument Serif",fontSize:24,fontWeight:400,marginBottom:8}}>Stop chasing. <Gold>Start earning.</Gold></h3>
            <p style={{color:T.textSub,fontSize:14,marginBottom:20}}>ChaseNahi automates all of this for you. Try free for 30 days.</p>
            <button className="btn-primary" onClick={onSignup} style={{padding:"13px 28px",fontSize:15}}>Start Free — No Card Needed <Ic n="arrow" s={15}/></button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div style={{minHeight:"100vh",overflowX:"hidden"}}>
      <Noise/>

      {/* NAV */}
      <nav style={{position:"fixed",top:0,left:0,right:0,zIndex:100,background:scrolled?"rgba(10,10,11,.92)":"transparent",backdropFilter:scrolled?"blur(20px)":"none",borderBottom:scrolled?`1px solid ${T.border}`:"none",transition:"all .3s"}}>
        <div style={{maxWidth:1080,margin:"0 auto",padding:"0 20px",height:60,display:"flex",alignItems:"center",justifyContent:"space-between"}}>
          <div style={{display:"flex",alignItems:"center",gap:9}}>
            <div style={{width:30,height:30,borderRadius:8,background:`linear-gradient(135deg,${T.gold},${T.goldLight})`,display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0}}>
              <Ic n="zap" s={14} c="#0A0A0B"/>
            </div>
            <span style={{fontFamily:"Instrument Serif",fontSize:20}}>ChaseNahi</span>
          </div>
          <div style={{display:"flex",gap:8,alignItems:"center"}}>
            <button className="btn-ghost" onClick={onLogin} style={{fontSize:13,padding:"8px 14px"}}>Sign In</button>
            <button className="btn-primary" onClick={onSignup} style={{padding:"8px 16px",fontSize:13}}>Try Free</button>
          </div>
        </div>
      </nav>

      {/* PHASE 1 BANNER */}
      <div style={{background:`linear-gradient(135deg,rgba(200,150,12,.15),rgba(200,150,12,.05))`,borderBottom:`1px solid rgba(200,150,12,.2)`,padding:"10px 20px",textAlign:"center",marginTop:60}}>
        <p style={{fontSize:13,color:T.goldLight}}>
          🚀 <strong>We're in Phase 1!</strong> Join our growing community of Indian freelancers. Phase 2 features unlock after 500 members.
          <span onClick={()=>document.getElementById("roadmap")?.scrollIntoView({behavior:"smooth"})} style={{color:T.goldLight,textDecoration:"underline",cursor:"pointer",marginLeft:8}}>See roadmap →</span>
        </p>
      </div>

      {/* HERO */}
      <section style={{paddingTop:60,paddingBottom:60,maxWidth:840,margin:"0 auto",padding:"60px 20px",textAlign:"center",position:"relative"}}>
        <div style={{position:"absolute",top:60,left:"50%",transform:"translateX(-50%)",width:"min(700px,100%)",height:400,background:`radial-gradient(ellipse,rgba(200,150,12,.07) 0%,transparent 70%)`,pointerEvents:"none"}}/>
        <div className="fade-up">
          <div style={{display:"inline-flex",alignItems:"center",gap:7,background:"rgba(200,150,12,.08)",border:`1px solid rgba(200,150,12,.18)`,borderRadius:20,padding:"5px 14px",marginBottom:24}}>
            <div style={{width:6,height:6,borderRadius:"50%",background:T.green,animation:"pulse 2s ease-in-out infinite"}}/>
            <span style={{fontSize:11,color:T.goldLight,fontWeight:700}}>LIVE · Join 12+ freelancers already using ChaseNahi</span>
          </div>
        </div>
        <div className="fade-up" style={{animationDelay:".08s"}}>
          <h1 style={{fontFamily:"Instrument Serif",fontSize:"clamp(38px,7vw,72px)",lineHeight:1.08,marginBottom:20,fontWeight:400}}>
            Clients Ko Chase Karna<br/><Gold>Band Karo.</Gold>
          </h1>
        </div>
        <div className="fade-up" style={{animationDelay:".16s"}}>
          <p style={{fontSize:"clamp(15px,2vw,17px)",color:T.textSub,maxWidth:500,margin:"0 auto 32px",lineHeight:1.75}}>
            Automated payment reminders for Indian freelancers. Professional, perfectly timed, completely hands-off. Less than a chai a day ☕
          </p>
        </div>
        <div className="fade-up" style={{animationDelay:".22s",display:"flex",justifyContent:"center",gap:10,flexWrap:"wrap"}}>
          <button className="btn-primary" onClick={onSignup} style={{padding:"13px 28px",fontSize:15}}>
            Start Free — No Card Needed <Ic n="arrow" s={16}/>
          </button>
        </div>
        <div className="fade-up" style={{animationDelay:".28s",marginTop:14}}>
          <p style={{fontSize:12,color:T.textMuted}}>Free plan available · Pro at ₹299/month · Cancel anytime</p>
        </div>
      </section>

      {/* HOW IT WORKS */}
      <section style={{maxWidth:1080,margin:"0 auto 60px",padding:"0 20px"}}>
        <div style={{textAlign:"center",marginBottom:40}}>
          <h2 style={{fontFamily:"Instrument Serif",fontSize:"clamp(28px,4vw,44px)",fontWeight:400}}>Simple as <Gold>1, 2, 3</Gold></h2>
        </div>
        <div className="steps-grid" style={{display:"grid",gridTemplateColumns:"repeat(3,1fr)",gap:18}}>
          {[
            {n:"01",title:"Add Invoice",desc:"Client name, email, amount, due date. Done in 60 seconds."},
            {n:"02",title:"Reminders Go Out",desc:"Automatic emails at the perfect time. Professional, not pushy."},
            {n:"03",title:"You Get Paid",desc:"Clients pay. You mark it done. Move to the next project."},
          ].map((s,i)=>(
            <div key={i} className="card card-hover" style={{position:"relative",overflow:"hidden"}}>
              <div style={{fontFamily:"Instrument Serif",fontSize:72,color:T.surfaceEl,position:"absolute",top:-10,right:12,lineHeight:1,userSelect:"none"}}>{s.n}</div>
              <span className="badge badge-gold" style={{marginBottom:14}}>Step {s.n}</span>
              <h3 style={{fontSize:17,fontWeight:700,color:T.text,marginBottom:7}}>{s.title}</h3>
              <p style={{fontSize:13,color:T.textSub,lineHeight:1.7}}>{s.desc}</p>
            </div>
          ))}
        </div>
      </section>

      {/* FEATURES */}
      <section style={{maxWidth:1080,margin:"0 auto 60px",padding:"0 20px"}}>
        <div style={{textAlign:"center",marginBottom:40}}>
          <h2 style={{fontFamily:"Instrument Serif",fontSize:"clamp(28px,4vw,44px)",fontWeight:400}}>Everything You Need.<br/><Gold>Nothing You Don't.</Gold></h2>
        </div>
        <div className="features-grid" style={{display:"grid",gridTemplateColumns:"repeat(2,1fr)",gap:16}}>
          {[
            {icon:"zap",title:"60-Second Setup",desc:"Add your invoice, set the due date. We handle everything else automatically."},
            {icon:"bell",title:"3-Stage Auto Reminders",desc:"Pre-due, due date, and overdue notices. Right tone, right time, every time."},
            {icon:"eye",title:"Real-Time Dashboard",desc:"See every invoice status live. Know who paid, who's late, who needs a push."},
            {icon:"shield",title:"Professional Emails",desc:"Your name, your phone number, your brand. Clients think you personally followed up."},
          ].map((f,i)=>(
            <div key={i} className="card card-hover" style={{display:"flex",gap:16}}>
              <div style={{width:42,height:42,borderRadius:11,background:"rgba(200,150,12,.08)",border:`1px solid rgba(200,150,12,.12)`,display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0}}>
                <Ic n={f.icon} s={18} c={T.goldLight}/>
              </div>
              <div>
                <h3 style={{fontSize:15,fontWeight:700,color:T.text,marginBottom:5}}>{f.title}</h3>
                <p style={{fontSize:13,color:T.textSub,lineHeight:1.7}}>{f.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* PRICING */}
      <section style={{maxWidth:1080,margin:"0 auto 60px",padding:"0 20px"}}>
        <div style={{textAlign:"center",marginBottom:40}}>
          <h2 style={{fontFamily:"Instrument Serif",fontSize:"clamp(28px,4vw,44px)",fontWeight:400}}>Simple, <Gold>Honest Pricing</Gold></h2>
          <p style={{color:T.textSub,marginTop:8,fontSize:14}}>Start free. Upgrade when you're ready.</p>
          {/* Toggle */}
          <div style={{display:"inline-flex",alignItems:"center",gap:12,marginTop:20,background:T.surfaceEl,border:`1px solid ${T.border}`,borderRadius:30,padding:"8px 16px"}}>
            <span style={{fontSize:13,color:yearly?T.textMuted:T.text,fontWeight:yearly?400:700}}>Monthly</span>
            <label className="toggle-switch">
              <input type="checkbox" checked={yearly} onChange={e=>setYearly(e.target.checked)}/>
              <span className="toggle-slider"/>
            </label>
            <span style={{fontSize:13,color:yearly?T.text:T.textMuted,fontWeight:yearly?700:400}}>Yearly</span>
            {yearly && <span className="badge badge-green" style={{fontSize:9}}>Save ₹1,089</span>}
          </div>
        </div>
        <div className="pricing-grid" style={{display:"grid",gridTemplateColumns:"repeat(2,1fr)",gap:20,maxWidth:760,margin:"0 auto"}}>
          {/* FREE */}
          <div className="card" style={{position:"relative"}}>
            <h3 style={{fontSize:18,fontWeight:700,marginBottom:4}}>Free</h3>
            <p style={{fontSize:13,color:T.textSub,marginBottom:20}}>Get started, no risk</p>
            <div style={{fontFamily:"Instrument Serif",fontSize:42,fontWeight:400,marginBottom:4}}>₹0</div>
            <div style={{fontSize:12,color:T.textMuted,marginBottom:24}}>forever free</div>
            {["3 invoices per month","Auto email reminders","Pay Now button in emails","Basic dashboard","WhatsApp support"].map((item,i)=>(
              <div key={i} style={{display:"flex",alignItems:"center",gap:9,padding:"8px 0",borderBottom:i<4?`1px solid ${T.border}`:"none"}}>
                <div style={{width:16,height:16,borderRadius:"50%",background:"rgba(34,197,94,.1)",display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0}}><Ic n="check" s={9} c={T.green}/></div>
                <span style={{fontSize:13,color:T.textSub}}>{item}</span>
              </div>
            ))}
            <button className="btn-ghost" onClick={onSignup} style={{width:"100%",justifyContent:"center",marginTop:20,padding:"12px"}}>
              Get Started Free
            </button>
          </div>
          {/* PRO */}
          <div style={{background:T.surface,border:`1px solid ${T.gold}`,borderRadius:14,padding:24,position:"relative",boxShadow:`0 0 40px rgba(200,150,12,.1)`}}>
            <div style={{position:"absolute",top:0,left:0,right:0,height:3,background:`linear-gradient(90deg,${T.gold},${T.goldLight})`,borderRadius:"14px 14px 0 0"}}/>
            <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",marginBottom:4}}>
              <h3 style={{fontSize:18,fontWeight:700}}>Pro</h3>
              <span className="badge badge-gold">POPULAR</span>
            </div>
            <p style={{fontSize:13,color:T.textSub,marginBottom:20}}>For serious freelancers</p>
            <div style={{fontFamily:"Instrument Serif",fontSize:42,fontWeight:400,marginBottom:4}}>
              <Gold>{yearly?"₹2,499":"₹299"}</Gold>
            </div>
            <div style={{fontSize:12,color:T.textMuted,marginBottom:4}}>{yearly?"per year — save ₹1,089":"per month"}</div>
            <div style={{fontSize:12,color:T.goldLight,marginBottom:20}}>☕ Less than a chai a day</div>
            {["Unlimited invoices","Auto email reminders","Pay Now button in emails","Full dashboard","Priority WhatsApp support"].map((item,i)=>(
              <div key={i} style={{display:"flex",alignItems:"center",gap:9,padding:"8px 0",borderBottom:i<4?`1px solid ${T.border}`:"none"}}>
                <div style={{width:16,height:16,borderRadius:"50%",background:"rgba(200,150,12,.1)",display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0}}><Ic n="check" s={9} c={T.goldLight}/></div>
                <span style={{fontSize:13,color:T.textSub}}>{item}</span>
              </div>
            ))}
            <button className="btn-primary" onClick={onSignup} style={{width:"100%",justifyContent:"center",marginTop:20,padding:"12px"}}>
              Start 30-Day Free Trial <Ic n="arrow" s={14}/>
            </button>
            <p style={{fontSize:11,color:T.textMuted,textAlign:"center",marginTop:8}}>No credit card required</p>
          </div>
        </div>
      </section>

      {/* ROADMAP */}
      <section id="roadmap" style={{maxWidth:1080,margin:"0 auto 60px",padding:"0 20px"}}>
        <div style={{textAlign:"center",marginBottom:40}}>
          <span style={{fontSize:10,color:T.goldLight,fontWeight:700,letterSpacing:"1.2px",textTransform:"uppercase"}}>Transparency</span>
          <h2 style={{fontFamily:"Instrument Serif",fontSize:"clamp(28px,4vw,44px)",fontWeight:400,marginTop:10}}>Our Public <Gold>Roadmap</Gold></h2>
          <p style={{color:T.textSub,marginTop:8,fontSize:14,maxWidth:520,margin:"8px auto 0"}}>We believe in building in public. Here's exactly what we're working on and what's coming next.</p>
          <div style={{marginTop:20,background:`rgba(200,150,12,.08)`,border:`1px solid rgba(200,150,12,.2)`,borderRadius:12,padding:"12px 20px",display:"inline-block"}}>
            <p style={{fontSize:13,color:T.goldLight}}>🎯 <strong>Community Goal:</strong> 500 members unlocks Phase 2 features for everyone</p>
          </div>
        </div>
        <div className="roadmap-grid" style={{display:"grid",gridTemplateColumns:"repeat(3,1fr)",gap:20}}>
          {roadmap.map((r,i)=>(
            <div key={i} className="card" style={{border:`1px solid ${r.status==="live"?T.green:r.status==="soon"?T.gold:T.border}`,position:"relative",overflow:"hidden"}}>
              {r.status==="live" && <div style={{position:"absolute",top:0,left:0,right:0,height:3,background:`linear-gradient(90deg,${T.green},#16A34A)`}}/>}
              {r.status==="soon" && <div style={{position:"absolute",top:0,left:0,right:0,height:3,background:`linear-gradient(90deg,${T.gold},${T.goldLight})`}}/>}
              <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:16}}>
                <div>
                  <span style={{fontSize:24}}>{r.icon}</span>
                  <div style={{fontSize:16,fontWeight:700,color:T.text,marginTop:4}}>{r.phase}</div>
                </div>
                <span className={`badge badge-${r.status==="live"?"green":r.status==="soon"?"amber":"blue"}`}>
                  {r.status==="live"?"LIVE NOW":r.status==="soon"?"COMING SOON":"FUTURE"}
                </span>
              </div>
              {r.unlock && <div style={{background:`rgba(200,150,12,.08)`,border:`1px solid rgba(200,150,12,.15)`,borderRadius:8,padding:"8px 12px",marginBottom:14,fontSize:11,color:T.goldLight}}>🔒 {r.unlock}</div>}
              <div style={{display:"flex",flexDirection:"column",gap:8}}>
                {r.items.map((item,j)=>(
                  <div key={j} style={{display:"flex",alignItems:"center",gap:8}}>
                    <div style={{width:5,height:5,borderRadius:"50%",background:r.status==="live"?T.green:r.status==="soon"?T.gold:T.textMuted,flexShrink:0}}/>
                    <span style={{fontSize:13,color:r.status==="live"?T.text:T.textSub}}>{item}</span>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* TESTIMONIALS */}
      <section style={{maxWidth:1080,margin:"0 auto 60px",padding:"0 20px"}}>
        <div style={{textAlign:"center",marginBottom:40}}>
          <h2 style={{fontFamily:"Instrument Serif",fontSize:"clamp(28px,4vw,44px)",fontWeight:400}}>Freelancers <Gold>Love It</Gold></h2>
        </div>
        <div className="testimonials-grid" style={{display:"grid",gridTemplateColumns:"repeat(3,1fr)",gap:16}}>
          {[
            {name:"Priya M.",role:"UI Designer · Pune",text:"Recovered ₹42,000 in my first month. Clients actually apologised for being late.",stars:5},
            {name:"Rahul S.",role:"Content Writer · Mumbai",text:"I used to dread follow-ups. Now it happens while I sleep. 94% collection rate.",stars:5},
            {name:"Ankita T.",role:"Marketer · Delhi",text:"My clients take payment terms seriously now. Feels like having a proper accounts team.",stars:5},
          ].map((t,i)=>(
            <div key={i} className="card card-hover">
              <div style={{display:"flex",gap:2,marginBottom:12}}>{[...Array(t.stars)].map((_,j)=><span key={j} style={{color:T.goldLight,fontSize:13}}>★</span>)}</div>
              <p style={{fontSize:13,color:T.textSub,lineHeight:1.8,marginBottom:16,fontStyle:"italic"}}>"{t.text}"</p>
              <div style={{display:"flex",alignItems:"center",gap:9}}>
                <div style={{width:32,height:32,borderRadius:"50%",background:`linear-gradient(135deg,${T.goldDim},${T.gold})`,display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0}}>
                  <span style={{fontSize:12,fontWeight:700,color:"#0A0A0B"}}>{t.name[0]}</span>
                </div>
                <div>
                  <div style={{fontSize:13,fontWeight:700,color:T.text}}>{t.name}</div>
                  <div style={{fontSize:11,color:T.textMuted}}>{t.role}</div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* BLOG */}
      <section style={{maxWidth:1080,margin:"0 auto 60px",padding:"0 20px"}}>
        <div style={{textAlign:"center",marginBottom:40}}>
          <span style={{fontSize:10,color:T.goldLight,fontWeight:700,letterSpacing:"1.2px",textTransform:"uppercase"}}>Resources</span>
          <h2 style={{fontFamily:"Instrument Serif",fontSize:"clamp(28px,4vw,44px)",fontWeight:400,marginTop:10}}>For Indian <Gold>Freelancers</Gold></h2>
          <p style={{color:T.textSub,marginTop:8,fontSize:14}}>Practical guides to get paid faster and grow your freelance business</p>
        </div>
        <div className="steps-grid" style={{display:"grid",gridTemplateColumns:"repeat(3,1fr)",gap:18}}>
          {blogs.map((b,i)=>(
            <div key={i} className="card card-hover" style={{cursor:"pointer",display:"flex",flexDirection:"column"}} onClick={()=> b.url ? window.location.href = b.url : openBlog(b.slug)}>
              <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",marginBottom:12}}>
                <span className="badge badge-gold">{b.tag}</span>
                <span style={{fontSize:11,color:T.textMuted}}>{b.mins}</span>
              </div>
              <h3 style={{fontSize:15,fontWeight:700,color:T.text,marginBottom:10,lineHeight:1.4,flex:1}}>{b.title}</h3>
              <p style={{fontSize:13,color:T.textSub,lineHeight:1.7,marginBottom:14}}>{b.excerpt}</p>
              <div style={{display:"flex",alignItems:"center",gap:6,color:T.goldLight,fontSize:13,fontWeight:600}}>
                Read article <Ic n="arrow" s={13} c={T.goldLight}/>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* CTA */}
      <section style={{maxWidth:1080,margin:"0 auto 60px",padding:"0 20px"}}>
        <div style={{background:T.surface,border:`1px solid ${T.border}`,borderRadius:20,padding:"48px 32px",textAlign:"center",position:"relative",overflow:"hidden"}}>
          <div style={{position:"absolute",top:"50%",left:"50%",transform:"translate(-50%,-50%)",width:600,height:300,background:`radial-gradient(ellipse,rgba(200,150,12,.06) 0%,transparent 70%)`,pointerEvents:"none"}}/>
          <h2 style={{fontFamily:"Instrument Serif",fontSize:"clamp(28px,4vw,40px)",fontWeight:400,marginBottom:14}}>
            Aapka Paisa Wait Kar Raha Hai.<br/><Gold>Jao Le Lo.</Gold>
          </h2>
          <p style={{fontSize:15,color:T.textSub,marginBottom:28,maxWidth:480,margin:"0 auto 28px"}}>
            Join 12+ Indian freelancers who stopped chasing clients and started getting paid on time.
          </p>
          <button className="btn-primary" onClick={onSignup} style={{padding:"14px 32px",fontSize:15}}>
            ChaseNahi Shuru Karo — Free <Ic n="arrow" s={16}/>
          </button>
        </div>
      </section>

      {/* FOOTER */}
      <footer style={{borderTop:`1px solid ${T.border}`,padding:"32px 20px"}}>
        <div style={{maxWidth:1080,margin:"0 auto",display:"flex",justifyContent:"space-between",alignItems:"center",flexWrap:"wrap",gap:16}}>
          <div style={{display:"flex",alignItems:"center",gap:8}}>
            <div style={{width:24,height:24,borderRadius:6,background:`linear-gradient(135deg,${T.gold},${T.goldLight})`,display:"flex",alignItems:"center",justifyContent:"center"}}>
              <Ic n="zap" s={12} c="#0A0A0B"/>
            </div>
            <span style={{fontFamily:"Instrument Serif",fontSize:16}}>ChaseNahi</span>
          </div>
          <div style={{display:"flex",gap:20,flexWrap:"wrap"}}>
          <button onClick={onPrivacy} style={{background:"none",border:"none",color:T.textMuted,cursor:"pointer",fontFamily:"Cabinet Grotesk",fontSize:13}}>
  Privacy Policy
</button>

<button onClick={onTerms} style={{background:"none",border:"none",color:T.textMuted,cursor:"pointer",fontFamily:"Cabinet Grotesk",fontSize:13}}>
  Terms & Conditions
</button>
          </div>
          <p style={{fontSize:11,color:T.textMuted}}>© 2026 ChaseNahi · Made with ❤️ in India · Data never sold</p>
        </div>
      </footer>
    </div>
  );
};

// ═══════════════════════════════════════════════════════════════════════════
// PHONE SETUP MODAL — shows on first login if phone missing
// ═══════════════════════════════════════════════════════════════════════════
const PhoneSetupModal = ({user,onComplete}) => {
  const [phone,setPhone] = useState("");
  const [name,setName] = useState(user?.user_metadata?.full_name||"");
  const [saving,setSaving] = useState(false);
  const [error,setError] = useState("");

  const save = async () => {
    if (!phone||phone.length<10){setError("Please enter a valid phone number.");return;}
    if (!name){setError("Please enter your name.");return;}
    setSaving(true);
    const {error:e} = await supabase.from("profiles").upsert({
      id:user.id, full_name:name, email:user.email, phone
    });
    if (e){setError("Failed to save. Please try again.");setSaving(false);return;}
    // Notify admin
    const {subject,html} = buildAdminEmail("signup",{
      "Name":name,"Email":user.email,"Phone":phone,"Time":new Date().toLocaleString("en-IN")
    });
    await sendEmail({to:ADMIN_EMAIL,toName:"ChaseNahi Admin",subject,html});
    onComplete({full_name:name,phone,email:user.email});
    setSaving(false);
  };

  return (
    <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,.85)",zIndex:300,display:"flex",alignItems:"center",justifyContent:"center",padding:20,backdropFilter:"blur(8px)"}}>
      <div className="fade-in" style={{background:T.surface,border:`1px solid ${T.border}`,borderRadius:20,padding:"36px",width:"100%",maxWidth:440,animation:"modalIn .3s ease forwards"}}>
        <div style={{width:48,height:48,borderRadius:12,background:`linear-gradient(135deg,${T.gold},${T.goldLight})`,display:"flex",alignItems:"center",justifyContent:"center",marginBottom:20}}>
          <Ic n="phone" s={22} c="#0A0A0B"/>
        </div>
        <h2 style={{fontFamily:"Instrument Serif",fontSize:26,fontWeight:400,marginBottom:6}}>Complete Your Profile</h2>
        <p style={{fontSize:13,color:T.textSub,marginBottom:24}}>Your phone number appears in reminder emails so clients know who to contact. This is required to start sending reminders.</p>
        <div style={{display:"flex",flexDirection:"column",gap:14}}>
          <div>
            <label className="label">Your Full Name *</label>
            <input className="input-field" placeholder="Sanket Jani" value={name} onChange={e=>setName(e.target.value)}/>
          </div>
          <div>
            <label className="label">Your Phone Number *</label>
            <input className="input-field" placeholder="+91 79841 77249" value={phone} onChange={e=>setPhone(e.target.value)} type="tel"/>
            <p style={{fontSize:11,color:T.textMuted,marginTop:5}}>This will appear in emails to your clients so they can reach you directly.</p>
          </div>
          {error && <div style={{background:"rgba(239,68,68,.08)",border:"1px solid rgba(239,68,68,.2)",borderRadius:8,padding:"10px 14px",fontSize:13,color:T.red}}>{error}</div>}
          <button className="btn-primary" onClick={save} disabled={saving} style={{justifyContent:"center",padding:"13px",fontSize:14,marginTop:4}}>
            {saving?<><span className="spinner"/>Saving...</>:<>Complete Setup <Ic n="arrow" s={15}/></>}
          </button>
        </div>
      </div>
    </div>
  );
};

// ═══════════════════════════════════════════════════════════════════════════
// AUTH PAGE
// ═══════════════════════════════════════════════════════════════════════════
const Auth = ({mode:initialMode,onBack,onSuccess}) => {
  const [mode,setMode] = useState(initialMode);
  const [form,setForm] = useState({name:"",email:"",password:""});
  const [loading,setLoading] = useState(false);
  const [error,setError] = useState("");
  const [showPass,setShowPass] = useState(false);
  const [forgotSent,setForgotSent] = useState(false);
  const handle = e=>setForm(p=>({...p,[e.target.name]:e.target.value}));
  const switchMode = m=>{setMode(m);setError("");setForgotSent(false);setForm({name:"",email:"",password:""});};

  const submit = async () => {
    setError("");
    if (!form.email){setError("Please enter your email.");return;}
    if (mode==="forgot"){
      setLoading(true);
      const {error:e} = await supabase.auth.resetPasswordForEmail(form.email,{redirectTo:"https://chasenahi.in/reset-password"});
      setLoading(false);
      if (e){setError(e.message);return;}
      setForgotSent(true);return;
    }
    if (!form.password||form.password.length<6){setError("Password must be at least 6 characters.");return;}
    if (mode==="signup"&&!form.name){setError("Please enter your name.");return;}
    setLoading(true);
    try {
      if (mode==="signup"){
        const {data,error:e} = await supabase.auth.signUp({email:form.email,password:form.password,options:{data:{full_name:form.name}}});
        if (e){setError(e.message);setLoading(false);return;}
        if (data.user) onSuccess(data.user);
      } else {
        const {data,error:e} = await supabase.auth.signInWithPassword({email:form.email,password:form.password});
        if (e){setError("Invalid email or password.");setLoading(false);return;}
        if (data.user) onSuccess(data.user);
      }
    } catch {setError("Something went wrong. Please try again.");}
    setLoading(false);
  };

  const titles={signup:"Start Getting Paid",login:"Welcome Back",forgot:"Reset Password"};
  const subs={signup:"30 days free · No credit card · Cancel anytime",login:"Sign in to your ChaseNahi account",forgot:"We'll send a reset link to your email"};

  return (
    <div style={{minHeight:"100vh",display:"flex",alignItems:"center",justifyContent:"center",padding:"20px",position:"relative"}}>
      <Noise/>
      <div style={{position:"absolute",top:"30%",left:"50%",transform:"translateX(-50%)",width:"min(500px,100%)",height:400,background:`radial-gradient(ellipse,rgba(200,150,12,.06) 0%,transparent 70%)`,pointerEvents:"none"}}/>
      <div className="fade-up" style={{width:"100%",maxWidth:420}}>
        <button onClick={onBack} className="btn-ghost" style={{marginBottom:28,padding:"7px 14px",fontSize:12}}>← Back</button>
        <div style={{display:"flex",alignItems:"center",gap:9,marginBottom:32}}>
          <div style={{width:34,height:34,borderRadius:9,background:`linear-gradient(135deg,${T.gold},${T.goldLight})`,display:"flex",alignItems:"center",justifyContent:"center"}}>
            <Ic n="zap" s={15} c="#0A0A0B"/>
          </div>
          <span style={{fontFamily:"Instrument Serif",fontSize:20}}>ChaseNahi</span>
        </div>
        <h1 style={{fontFamily:"Instrument Serif",fontSize:"clamp(28px,5vw,34px)",fontWeight:400,marginBottom:6}}>{titles[mode]}</h1>
        <p style={{fontSize:13,color:T.textSub,marginBottom:28}}>{subs[mode]}</p>
        {forgotSent?(
          <div style={{background:"rgba(34,197,94,.08)",border:"1px solid rgba(34,197,94,.2)",borderRadius:12,padding:"24px",textAlign:"center"}}>
            <div style={{fontSize:36,marginBottom:12}}>📧</div>
            <h3 style={{fontSize:16,fontWeight:700,color:T.text,marginBottom:8}}>Check Your Email</h3>
            <p style={{fontSize:13,color:T.textSub,marginBottom:20}}>Reset link sent to <strong>{form.email}</strong></p>
            <button onClick={()=>switchMode("login")} className="btn-primary" style={{width:"100%",justifyContent:"center"}}>Back to Sign In</button>
          </div>
        ):(
          <div style={{display:"flex",flexDirection:"column",gap:14}}>
            {mode==="signup"&&<div><label className="label">Your Name</label><input className="input-field" name="name" placeholder="Rahul Sharma" value={form.name} onChange={handle} onKeyDown={e=>e.key==="Enter"&&submit()}/></div>}
            <div><label className="label">Email Address</label><input className="input-field" name="email" type="email" placeholder="you@example.com" value={form.email} onChange={handle} onKeyDown={e=>e.key==="Enter"&&submit()}/></div>
            {mode!=="forgot"&&(
              <div>
                <label className="label">Password</label>
                <div style={{position:"relative"}}>
                  <input className="input-field" name="password" type={showPass?"text":"password"} placeholder="Min. 6 characters" value={form.password} onChange={handle} onKeyDown={e=>e.key==="Enter"&&submit()} style={{paddingRight:44}}/>
                  <button onClick={()=>setShowPass(p=>!p)} style={{position:"absolute",right:12,top:"50%",transform:"translateY(-50%)",background:"none",border:"none",cursor:"pointer",color:T.textMuted}}><Ic n="eye" s={16}/></button>
                </div>
              </div>
            )}
            {mode==="login"&&<div style={{textAlign:"right",marginTop:-6}}><span onClick={()=>switchMode("forgot")} style={{fontSize:12,color:T.goldLight,cursor:"pointer",textDecoration:"underline"}}>Forgot password?</span></div>}
            {error&&<div style={{background:"rgba(239,68,68,.08)",border:"1px solid rgba(239,68,68,.2)",borderRadius:8,padding:"10px 14px",fontSize:13,color:T.red}}>{error}</div>}
            <button className="btn-primary" onClick={submit} disabled={loading} style={{width:"100%",justifyContent:"center",padding:"13px",fontSize:14,marginTop:4}}>
              {loading?<><span className="spinner"/>{mode==="signup"?"Creating...":mode==="forgot"?"Sending...":"Signing in..."}</>:<>{mode==="signup"?"Create Free Account":mode==="forgot"?"Send Reset Link":"Sign In"}<Ic n="arrow" s={15}/></>}
            </button>
          </div>
        )}
        {!forgotSent&&(
          <p style={{fontSize:12,color:T.textMuted,textAlign:"center",marginTop:20}}>
            {mode==="signup"&&<>Already have an account? <span onClick={()=>switchMode("login")} style={{color:T.goldLight,cursor:"pointer",textDecoration:"underline"}}>Sign in</span></>}
            {mode==="login"&&<>No account? <span onClick={()=>switchMode("signup")} style={{color:T.goldLight,cursor:"pointer",textDecoration:"underline"}}>Sign up free</span></>}
            {mode==="forgot"&&<>Remember it? <span onClick={()=>switchMode("login")} style={{color:T.goldLight,cursor:"pointer",textDecoration:"underline"}}>Back to sign in</span></>}
          </p>
        )}
      </div>
    </div>
  );
};

// ═══════════════════════════════════════════════════════════════════════════
// ADD INVOICE MODAL
const AddInvoiceModal = ({user,profile,onClose,onSuccess}) => {
  const [form,setForm] = useState({client_name:"",client_email:"",client_phone:"",project_name:"",amount:"",due_date:"",payment_link:"",notes:"",reminder_days:"3"});
  const [saving,setSaving] = useState(false);
  const [error,setError] = useState("");
  const handle = e=>setForm(p=>({...p,[e.target.name]:e.target.value}));
// ═══════════════════════════════════════════════════════════════════════════
const save = async () => {
  setError("");

  if (!form.client_name || !form.client_email || !form.amount || !form.due_date) {
    setError("Please fill all required fields.");
    return;
  }
const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

if (!emailRegex.test(form.client_email.trim())) {
  setError("Please enter a valid client email address.");
  return;
}
  if (isNaN(parseFloat(form.amount)) || parseFloat(form.amount) <= 0) {
    setError("Please enter a valid amount.");
    return;
  }

  setSaving(true);
const rawPayment = form.payment_link.trim();

const finalPaymentLink = rawPayment
  ? rawPayment.startsWith("http://") || rawPayment.startsWith("https://")
    ? rawPayment
    : `upi://pay?pa=${encodeURIComponent(rawPayment)}&pn=${encodeURIComponent(profile?.full_name || "Freelancer")}&am=${parseFloat(form.amount)}&cu=INR`
  : null;
  const invData = {
  user_id: user.id,
  client_name: form.client_name.trim(),
  client_email: form.client_email.trim().toLowerCase(),
  client_phone: form.client_phone.trim() || null,
  project_name: form.project_name.trim() || "Project",
  amount: parseFloat(form.amount),
  due_date: form.due_date,
  payment_link: finalPaymentLink,
  notes: form.notes.trim() || null,
  invoice_number: genInvNum(),
  status: "pending",
};

  const { data: newInvoice, error: e } = await supabase
  .from("invoices")
  .insert(invData)
  .select()
  .single();

  if (e) {
    setError("Failed to save. Please try again.");
    setSaving(false);
    return;
  }
  const dueDate = new Date(form.due_date);

const oneDayBefore = new Date(dueDate);
oneDayBefore.setDate(dueDate.getDate() - 1);

const dueToday = new Date(dueDate);

const overdue = new Date(dueDate);
overdue.setDate(dueDate.getDate() + 5);

// 3. Insert reminders
await supabase.from("reminders").insert([
  {
    invoice_id: newInvoice.id,
    user_id: user.id,
    reminder_type: "before_due",
    channel: "email",
    scheduled_at: oneDayBefore.toISOString(),
    status: "pending",
    email_subject: `Reminder: Invoice #${newInvoice.invoice_number} due soon`
  },
  {
    invoice_id: newInvoice.id,
    user_id: user.id,
    reminder_type: "due_today",
    channel: "email",
    scheduled_at: dueToday.toISOString(),
    status: "pending",
    email_subject: `Reminder: Invoice #${newInvoice.invoice_number} due today`
  },
  {
    invoice_id: newInvoice.id,
    user_id: user.id,
    reminder_type: "overdue",
    channel: "email",
    scheduled_at: overdue.toISOString(),
    status: "pending",
    email_subject: `Reminder: Invoice #${newInvoice.invoice_number} overdue`
  }
]);

// 4. Continue your existing flow
setSaving(false);
onSuccess();

  // Close modal + show success first
  setSaving(false);
  onSuccess();

  // Admin notification should not block user experience
  try {
    const { subject, html } = buildAdminEmail("invoice_created", {
      "Freelancer": profile?.full_name || user.email,
      "Client": form.client_name,
      "Amount": fmt(parseFloat(form.amount)),
      "Due Date": fmtDate(form.due_date),
      "Invoice": invData.invoice_number,
    });

    sendEmail({
      to: ADMIN_EMAIL,
      toName: "ChaseNahi Admin",
      subject,
      html,
    });

    supabase.from("admin_logs").insert({
      event_type: "invoice_created",
      user_id: user.id,
      user_name: profile?.full_name,
      user_email: user.email,
      details: invData,
    });
  } catch {}
};

  const days=parseInt(form.reminder_days);
  const dueDate=form.due_date?new Date(form.due_date):null;
  const preDate=dueDate?new Date(dueDate.getTime()-days*86400000).toLocaleDateString("en-IN",{day:"numeric",month:"short"}):"—";
  const postDate=dueDate?new Date(dueDate.getTime()+5*86400000).toLocaleDateString("en-IN",{day:"numeric",month:"short"}):"—";

  return (
    <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,.8)",zIndex:200,display:"flex",alignItems:"center",justifyContent:"center",padding:16,backdropFilter:"blur(6px)"}}>
      <div className="modal-inner fade-in" style={{background:T.surface,border:`1px solid ${T.border}`,borderRadius:18,padding:"28px",width:"100%",maxWidth:540,maxHeight:"90vh",overflowY:"auto",position:"relative",animation:"modalIn .3s ease forwards"}}>
        <button onClick={onClose} style={{position:"absolute",top:16,right:16,background:"none",border:"none",cursor:"pointer",color:T.textMuted}}><Ic n="x" s={18}/></button>
        <h2 style={{fontFamily:"Instrument Serif",fontSize:24,fontWeight:400,marginBottom:4}}>New Invoice</h2>
        <p style={{fontSize:13,color:T.textSub,marginBottom:22}}>Add client details and we'll auto-schedule reminders.</p>
        <div style={{display:"flex",flexDirection:"column",gap:12}}>
          <div className="form-grid" style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:10}}>
            <div><label className="label">Client Name *</label><input className="input-field" name="client_name" placeholder="Arjun Mehta" value={form.client_name} onChange={handle}/></div>
            <div><label className="label">Client Phone</label><input className="input-field" name="client_phone" placeholder="+91 98765 43210" value={form.client_phone} onChange={handle}/></div>
          </div>
          <div><label className="label">Client Email *</label><input className="input-field" name="client_email" type="email" placeholder="client@company.com" value={form.client_email} onChange={handle}/></div>
          <div><label className="label">Project / Description</label><input className="input-field" name="project_name" placeholder="Website Redesign, Logo Design..." value={form.project_name} onChange={handle}/></div>
          <div className="form-grid" style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:10}}>
            <div><label className="label">Amount (₹) *</label><input className="input-field" name="amount" type="number" placeholder="45000" value={form.amount} onChange={handle} min="1"/></div>
            <div><label className="label">Due Date *</label><input className="input-field" name="due_date" type="date" value={form.due_date} onChange={handle} min={new Date().toISOString().split("T")[0]}/></div>
          </div>
          <div>
            <label className="label">Payment Link (optional)</label>
            <input className="input-field" name="payment_link" placeholder="Paste UPI / Razorpay / GPay payment link (optional)" value={form.payment_link} onChange={handle}/>
            <p style={{fontSize:11,color:T.textMuted,marginTop:4}}>If added, a "Pay Now" button appears in reminder emails for easy payment.</p>
          </div>
          <div><label className="label">First Reminder</label>
            <select className="input-field" name="reminder_days" value={form.reminder_days} onChange={handle}>
              <option value="1">1 day before due date</option>
              <option value="3">3 days before due date</option>
              <option value="5">5 days before due date</option>
              <option value="7">7 days before due date</option>
            </select>
          </div>
          {form.due_date&&(
            <div style={{background:`rgba(200,150,12,.05)`,border:`1px solid rgba(200,150,12,.12)`,borderRadius:10,padding:"12px 14px"}}>
              <div style={{fontSize:11,fontWeight:700,color:T.goldLight,letterSpacing:".4px",textTransform:"uppercase",marginBottom:8}}>📅 Reminder Schedule</div>
              {[{dot:T.goldLight,label:"Email 1 — Heads Up",when:preDate},{dot:T.amber,label:"Email 2 — Due Today",when:dueDate?fmtDate(form.due_date):"—"},{dot:T.red,label:"Email 3 — Overdue",when:postDate}].map((item,i)=>(
                <div key={i} style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:i<2?6:0}}>
                  <div style={{display:"flex",alignItems:"center",gap:7}}><div style={{width:6,height:6,borderRadius:"50%",background:item.dot,flexShrink:0}}/><span style={{fontSize:12,color:T.textSub}}>{item.label}</span></div>
                  <span className="mono" style={{fontSize:11,color:T.textMuted}}>{item.when}</span>
                </div>
              ))}
            </div>
          )}
          {error&&<div style={{background:"rgba(239,68,68,.08)",border:"1px solid rgba(239,68,68,.2)",borderRadius:8,padding:"10px 14px",fontSize:13,color:T.red}}>{error}</div>}
          <div style={{display:"flex",gap:10,marginTop:4}}>
            <button className="btn-ghost" onClick={onClose} style={{flex:1,justifyContent:"center"}}>Cancel</button>
            <button className="btn-primary" onClick={save} disabled={saving} style={{flex:2,justifyContent:"center",padding:"12px"}}>
              {saving?<><span className="spinner"/>Saving...</>:<><Ic n="zap" s={14}/>Activate Reminders</>}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

// ═══════════════════════════════════════════════════════════════════════════
// ADMIN PANEL
// ═══════════════════════════════════════════════════════════════════════════
const AdminPanel = ({onBack}) => {
  const [tab,setTab] = useState("users");
  const [users,setUsers] = useState([]);
  const [invoices,setInvoices] = useState([]);
  const [logs,setLogs] = useState([]);
  const [loading,setLoading] = useState(true);

  useEffect(()=>{
    const load = async () => {
      setLoading(true);
      const [u,inv,l] = await Promise.all([
        supabase.from("profiles").select("*").neq("email", ADMIN_EMAIL).order("created_at",{ascending:false}),
        supabase.from("invoices").select("*, profiles(full_name, email)").order("created_at",{ascending:false}),
        supabase.from("admin_logs").select("*").order("created_at",{ascending:false}).limit(50),
      ]);
      if (u.data) setUsers(u.data);
      if (inv.data) setInvoices(inv.data);
      if (l.data) setLogs(l.data);
      setLoading(false);
    };
    load();
  },[]);

  const deleteUser = async (id) => {
  if (!window.confirm("Delete this user and all their data? This cannot be undone.")) return;
  await supabase.from("invoices").delete().eq("user_id",id);
  await supabase.from("reminders").delete().eq("user_id",id);
  await supabase.from("admin_logs").delete().eq("user_id",id);
  await supabase.from("profiles").delete().eq("id",id);
  setUsers(p=>p.filter(u=>u.id!==id));
};
  const blockUser = async (id, currentlyBlocked) => {
  await supabase.from("profiles").update({is_blocked: !currentlyBlocked}).eq("id",id);
  setUsers(p=>p.map(u=>u.id===id?{...u,is_blocked:!currentlyBlocked}:u));
};

  const totalRevenue = invoices.filter(i=>i.status==="paid").reduce((a,b)=>a+Number(b.amount),0);

  return (
    <div style={{minHeight:"100vh",background:T.bg,padding:"0"}}>
      <div style={{background:T.surface,borderBottom:`1px solid ${T.border}`,padding:"16px 24px",display:"flex",alignItems:"center",justifyContent:"space-between"}}>
        <div style={{display:"flex",alignItems:"center",gap:12}}>
          <div style={{width:28,height:28,borderRadius:7,background:`linear-gradient(135deg,${T.gold},${T.goldLight})`,display:"flex",alignItems:"center",justifyContent:"center"}}><Ic n="zap" s={13} c="#0A0A0B"/></div>
          <span style={{fontFamily:"Instrument Serif",fontSize:18}}>ChaseNahi</span>
          <span className="badge badge-red">ADMIN</span>
        </div>
        <button onClick={onBack} className="btn-ghost" style={{fontSize:13}}>← Exit Admin</button>
      </div>
      <div style={{maxWidth:1200,margin:"0 auto",padding:"24px"}}>
        {/* STATS */}
        <div style={{display:"grid",gridTemplateColumns:"repeat(4,1fr)",gap:14,marginBottom:24}}>
          {[
            {l:"Total Users",v:users.length,c:T.blue},
            {l:"Total Invoices",v:invoices.length,c:T.amber},
            {l:"Paid Invoices",v:invoices.filter(i=>i.status==="paid").length,c:T.green},
            {l:"Revenue Tracked",v:fmt(totalRevenue),c:T.goldLight},
          ].map((s,i)=>(
            <div key={i} className="card" style={{padding:"16px"}}>
              <div style={{fontSize:10,color:T.textMuted,textTransform:"uppercase",letterSpacing:".4px",marginBottom:8,fontWeight:700}}>{s.l}</div>
              <div className="mono" style={{fontSize:24,color:s.c,fontWeight:500}}>{s.v}</div>
            </div>
          ))}
        </div>
        {/* TABS */}
        <div style={{display:"flex",gap:4,marginBottom:20,background:T.surfaceEl,border:`1px solid ${T.border}`,borderRadius:10,padding:4,width:"fit-content"}}>
          {[{id:"users",label:"Users"},{id:"invoices",label:"Invoices"},{id:"logs",label:"Activity Log"}].map(t=>(
            <button key={t.id} onClick={()=>setTab(t.id)} style={{padding:"8px 16px",borderRadius:8,border:"none",cursor:"pointer",fontFamily:"Cabinet Grotesk",fontSize:13,fontWeight:600,background:tab===t.id?T.surface:"transparent",color:tab===t.id?T.text:T.textMuted,transition:"all .15s"}}>{t.label}</button>
          ))}
        </div>
        {loading?<div style={{display:"flex",justifyContent:"center",padding:"60px 0"}}><div className="spinner-gold"/></div>:(
          <>
            {tab==="users"&&(
              <div className="card" style={{padding:0,overflow:"hidden"}}>
                <div style={{display:"grid",gridTemplateColumns:"1fr 1fr 1fr 120px 80px",gap:12,padding:"12px 18px",borderBottom:`1px solid ${T.border}`}}>
                  {["Name","Email","Phone","Status","Actions"].map((h,i)=><span key={i} style={{fontSize:10,color:T.textMuted,fontWeight:700,letterSpacing:".5px",textTransform:"uppercase"}}>{h}</span>)}
                </div>
                {users.map((u,i)=>(
                  <div key={u.id} className="table-row" style={{display:"grid",gridTemplateColumns:"1fr 1fr 1fr 120px 80px",gap:12,alignItems:"center",padding:"14px 18px",borderBottom:i<users.length-1?`1px solid ${T.border}`:"none"}}>
                    <div style={{fontSize:13,fontWeight:600,color:T.text}}>{u.full_name||"—"}</div>
                    <div style={{fontSize:12,color:T.textSub}}>{u.email}</div>
                    <div style={{fontSize:12,color:T.textSub}}>{u.phone||"—"}</div>
                    <span className={`badge badge-${u.is_blocked ? "red" : "green"}`}>
                    {u.is_blocked ? "Blocked" : "Active"}
                    </span>
                    <div style={{display:"flex",gap:5}}>
  <button onClick={()=>blockUser(u.id,u.is_blocked)} className="btn-ghost" style={{padding:"4px 8px",fontSize:11,color:u.is_blocked?T.green:T.amber,borderColor:u.is_blocked?"rgba(34,197,94,.3)":"rgba(245,158,11,.3)"}}>
    {u.is_blocked?"Unblock":"Block"}
  </button>
  <button onClick={()=>deleteUser(u.id)} className="btn-danger" style={{padding:"4px 8px",fontSize:11}}><Ic n="x" s={12}/></button>
</div>
                  </div>
                ))}
              </div>
            )}
            {tab==="invoices"&&(
              <div className="card" style={{padding:0,overflow:"hidden"}}>
                <div style={{display:"grid",gridTemplateColumns:"1fr 1fr 1fr 100px 90px",gap:12,padding:"12px 18px",borderBottom:`1px solid ${T.border}`}}>
                  {["Freelancer","Client","Amount","Due Date","Status"].map((h,i)=><span key={i} style={{fontSize:10,color:T.textMuted,fontWeight:700,letterSpacing:".5px",textTransform:"uppercase"}}>{h}</span>)}
                </div>
                {invoices.map((inv,i)=>(
                  <div key={inv.id} className="table-row" style={{display:"grid",gridTemplateColumns:"1fr 1fr 1fr 100px 90px",gap:12,alignItems:"center",padding:"14px 18px",borderBottom:i<invoices.length-1?`1px solid ${T.border}`:"none"}}>
                    <div><div style={{fontSize:13,fontWeight:600,color:T.text}}>{inv.profiles?.full_name||"Unknown"}</div><div style={{fontSize:11,color:T.textMuted}}>{inv.profiles?.email||"—"}</div></div>
                    <div style={{fontSize:13,fontWeight:600,color:T.text}}>{inv.client_name}</div>
                    <div className="mono" style={{fontSize:13,color:T.text}}>{fmt(inv.amount)}</div>
                    <div style={{fontSize:12,color:T.textSub}}>{fmtDate(inv.due_date)}</div>
                    <span className={`badge badge-${inv.status==="overdue"?"red":inv.status==="paid"?"green":"amber"}`}>{inv.status}</span>
                  </div>
                ))}
              </div>
            )}
            {tab==="logs"&&(
              <div style={{display:"flex",flexDirection:"column",gap:10}}>
                {logs.map((l,i)=>(
                  <div key={l.id} className="card" style={{display:"flex",alignItems:"center",gap:14,padding:"14px 18px"}}>
                    <div style={{width:36,height:36,borderRadius:9,background:`rgba(200,150,12,.08)`,border:`1px solid rgba(200,150,12,.15)`,display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0}}>
                      <Ic n={l.event_type==="signup"?"user":l.event_type==="paid"?"check":l.event_type==="reminder"?"mail":"book"} s={15} c={T.goldLight}/>
                    </div>
                    <div style={{flex:1}}>
                      <div style={{fontSize:13,fontWeight:700,color:T.text,marginBottom:2}}>{l.user_name||l.user_email||"Unknown"}</div>
                      <div style={{fontSize:11,color:T.textMuted}}>{l.event_type} · {fmtDate(l.created_at)}</div>
                    </div>
                    <span className="badge badge-gold" style={{fontSize:9}}>{l.event_type}</span>
                  </div>
                ))}
                {logs.length===0&&<div className="card" style={{textAlign:"center",padding:"40px",color:T.textMuted}}>No activity logged yet</div>}
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
};

// ═══════════════════════════════════════════════════════════════════════════
// DASHBOARD
// ═══════════════════════════════════════════════════════════════════════════
const Dashboard = ({user,onLogout}) => {
  const [tab,setTab] = useState("dashboard");
  const [invoices,setInvoices] = useState([]);
  const [reminders,setReminders] = useState([]);
  const [loading,setLoading] = useState(true);
  const [showAdd,setShowAdd] = useState(false);
  const [toast,setToast] = useState(null);
  const [profile,setProfile] = useState(null);
  const [sidebarOpen,setSidebarOpen] = useState(false);
  const [needsPhone,setNeedsPhone] = useState(false);
  const isAdmin = user.email===ADMIN_EMAIL;

  const showToast = (msg,type="success")=>{setToast({msg,type});setTimeout(()=>setToast(null),3500);};

  const openAddInvoice = () => {
  const isPro = profile?.plan === "pro" || profile?.subscription_status === "active";

  if (!isPro && invoices.length >= 3) {
    showToast("Free plan allows only 3 invoices. Upgrade to Pro.", "error");
    return;
  }

  setShowAdd(true);
};

  useEffect(()=>{
    const load = async () => {
      const {data} = await supabase.from("profiles").select("*").eq("id",user.id).single();
      if (data){setProfile(data);if(!data.phone)setNeedsPhone(true);}
      else setNeedsPhone(true);
    };
    load();
  },[user.id]);

  const loadInvoices = async () => {
    setLoading(true);
    const {data} = await supabase.from("invoices").select("*").eq("user_id",user.id).order("created_at",{ascending:false});
    if (data) setInvoices(data);
    setLoading(false);
  };

  const loadReminders = async () => {
    const {data} = await supabase.from("reminders").select("*, invoices(client_name,invoice_number)").eq("user_id",user.id).order("created_at",{ascending:false}).limit(20);
    if (data) setReminders(data);
  };

  useEffect(()=>{loadInvoices();loadReminders();},[]);

  useEffect(()=>{
    invoices.forEach(async inv=>{
      if (inv.status==="pending"&&daysUntil(inv.due_date)<0){
        await supabase.from("invoices").update({status:"overdue"}).eq("id",inv.id);
      }
    });
  },[invoices]);

  const sendReminder = async (inv,type) => {
    if (!inv.client_email || !inv.client_email.includes("@")) {
  showToast("Invalid email for this client", "error");
  return;
}
    const senderName = profile?.full_name||user.email?.split("@")[0]||"Your Freelancer";
    const senderPhone = profile?.phone||"";
    const {subject,html} = buildReminderEmail(inv,senderName,senderPhone,type);

    // Send to client
    const sent = await sendEmail({to:inv.client_email,toName:inv.client_name,subject,html,replyTo:user.email});
    if (!sent){showToast("Failed to send. Check Brevo settings.","error");return;}

    // Send copy to admin
    const adminDetails = {"Freelancer":senderName,"Phone":senderPhone,"Client":inv.client_name,"Client Email":inv.client_email,"Amount":fmt(inv.amount),"Invoice":inv.invoice_number,"Type":type};
    const adminEmail = buildAdminEmail("reminder",adminDetails);
    await sendEmail({to:ADMIN_EMAIL,toName:"ChaseNahi Admin",subject:adminEmail.subject,html:adminEmail.html});

    // Log to DB
    await supabase.from("reminders").insert({invoice_id:inv.id,user_id:user.id,reminder_type:type,channel:"email",scheduled_at:new Date().toISOString(),sent_at:new Date().toISOString(),status:"sent",email_subject:subject});
    const { error: logError } = await supabase.from("admin_logs").insert({
  event_type: "reminder",
  user_id: user.id,
  user_name: senderName,
  user_email: user.email,
  details: { client: inv.client_name, amount: inv.amount, type }
});

if (logError) {
  console.error("Admin log insert failed:", logError);
  showToast("Reminder sent, but admin log failed.", "error");
}

    showToast(`Reminder sent to ${inv.client_name} ✓`);
    loadReminders();
  };

  const markPaid = async (inv) => {
    await supabase.from("invoices").update({status:"paid"}).eq("id",inv.id);
    const senderName = profile?.full_name||user.email?.split("@")[0]||"Freelancer";

    // Send receipt to client
    const {subject,html} = buildPaidEmail(inv,senderName);
    await sendEmail({to:inv.client_email,toName:inv.client_name,subject,html});

    // Notify admin
    const adminEmail = buildAdminEmail("paid",{"Freelancer":senderName,"Client":inv.client_name,"Amount":fmt(inv.amount),"Invoice":inv.invoice_number});
    await sendEmail({to:ADMIN_EMAIL,toName:"ChaseNahi Admin",subject:adminEmail.subject,html:adminEmail.html});
    await supabase.from("admin_logs").insert({event_type:"paid",user_id:user.id,user_name:senderName,user_email:user.email,details:{client:inv.client_name,amount:inv.amount}}).catch(()=>{});

    showToast(`${fmt(inv.amount)} from ${inv.client_name} marked received! 🎉`);
    loadInvoices();
  };

  const deleteInvoice = async id => {
    await supabase.from("invoices").delete().eq("id",id);
    showToast("Invoice deleted.");
    loadInvoices();
  };

  const displayName = profile?.full_name||user.email?.split("@")[0]||"Freelancer";
  const outstanding = invoices.filter(i=>i.status!=="paid").reduce((a,b)=>a+Number(b.amount),0);
  const collected = invoices.filter(i=>i.status==="paid").reduce((a,b)=>a+Number(b.amount),0);
  const overdue = invoices.filter(i=>i.status==="overdue").length;

  const navItems = [
    {id:"dashboard",icon:"home",label:"Dashboard"},
    {id:"invoices",icon:"rupee",label:"Invoices"},
    {id:"reminders",icon:"bell",label:"Reminders"},
    {id:"account",icon:"user",label:"Account"},
    ...(isAdmin?[{id:"admin",icon:"shield",label:"Admin Panel"}]:[]),
  ];

  const handleNav = id => {setTab(id);setSidebarOpen(false);};

  if (tab==="admin"&&isAdmin) return <AdminPanel onBack={()=>setTab("dashboard")}/>;

  return (
    <div style={{display:"flex",minHeight:"100vh"}}>
      <Noise/>
      {needsPhone&&<PhoneSetupModal user={user} onComplete={p=>{setProfile(p);setNeedsPhone(false);}}/>}
      {sidebarOpen&&<div className="mobile-overlay" onClick={()=>setSidebarOpen(false)}/>}

      {/* SIDEBAR */}
      <aside className={`sidebar${sidebarOpen?" open":""}`} style={{width:216,background:T.surface,borderRight:`1px solid ${T.border}`,display:"flex",flexDirection:"column",position:"fixed",top:0,left:0,bottom:0,zIndex:200}}>
        <div style={{padding:"18px 16px",borderBottom:`1px solid ${T.border}`}}>
          <div style={{display:"flex",alignItems:"center",gap:8}}>
            <div style={{width:28,height:28,borderRadius:7,background:`linear-gradient(135deg,${T.gold},${T.goldLight})`,display:"flex",alignItems:"center",justifyContent:"center"}}><Ic n="zap" s={13} c="#0A0A0B"/></div>
            <span style={{fontFamily:"Instrument Serif",fontSize:17}}>ChaseNahi</span>
          </div>
        </div>
        <nav style={{flex:1,padding:"12px 8px"}}>
          {navItems.map(item=>(
            <button key={item.id} onClick={()=>handleNav(item.id)} className={`nav-item${tab===item.id?" active":""}`}>
              <Ic n={item.icon} s={15} c={tab===item.id?T.goldLight:T.textSub}/>{item.label}
            </button>
          ))}
        </nav>
        <div style={{padding:"12px 8px",borderTop:`1px solid ${T.border}`}}>
          <div style={{display:"flex",alignItems:"center",gap:9,padding:"10px 12px",marginBottom:4}}>
            <div style={{width:30,height:30,borderRadius:"50%",background:`linear-gradient(135deg,${T.goldDim},${T.gold})`,display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0}}>
              <span style={{fontSize:11,fontWeight:700,color:"#0A0A0B"}}>{displayName[0].toUpperCase()}</span>
            </div>
            <div style={{overflow:"hidden"}}>
              <div style={{fontSize:12,fontWeight:700,color:T.text,whiteSpace:"nowrap",overflow:"hidden",textOverflow:"ellipsis"}}>{displayName}</div>
              <span className="badge badge-gold" style={{fontSize:8,padding:"1px 5px"}}>FREE TRIAL</span>
            </div>
          </div>
          <button onClick={onLogout} className="nav-item" style={{color:T.textMuted}}><Ic n="logout" s={14} c={T.textMuted}/>Sign Out</button>
        </div>
      </aside>

      {/* MAIN */}
      <main className="main-content" style={{marginLeft:216,flex:1,padding:"24px",minHeight:"100vh"}}>
        {/* MOBILE HEADER */}
        <div className="mobile-header" style={{display:"flex",alignItems:"center",justifyContent:"space-between",marginBottom:20,paddingBottom:16,borderBottom:`1px solid ${T.border}`}}>
          <div style={{display:"flex",alignItems:"center",gap:8}}>
            <div style={{width:28,height:28,borderRadius:7,background:`linear-gradient(135deg,${T.gold},${T.goldLight})`,display:"flex",alignItems:"center",justifyContent:"center"}}><Ic n="zap" s={13} c="#0A0A0B"/></div>
            <span style={{fontFamily:"Instrument Serif",fontSize:17}}>ChaseNahi</span>
          </div>
          <button onClick={()=>setSidebarOpen(true)} style={{background:"none",border:"none",cursor:"pointer",color:T.text,padding:8}}><Ic n="menu" s={22}/></button>
        </div>

        {/* DASHBOARD */}
        {tab==="dashboard"&&(
          <div className="fade-in">
            <div style={{marginBottom:24}}>
              <h1 style={{fontFamily:"Instrument Serif",fontSize:"clamp(24px,4vw,30px)",fontWeight:400,marginBottom:4}}>Namaste, <Gold>{displayName}</Gold> 👋</h1>
              <p style={{fontSize:13,color:T.textSub}}>Your payment recovery overview</p>
            </div>
            <div className="stats-grid" style={{display:"grid",gridTemplateColumns:"repeat(4,1fr)",gap:12,marginBottom:20}}>
              {[
                {l:"Outstanding",v:fmt(outstanding),icon:"rupee",c:T.amber,sub:`${invoices.filter(i=>i.status!=="paid").length} invoices`},
                {l:"Collected",v:fmt(collected),icon:"check",c:T.green,sub:"This period"},
                {l:"Overdue",v:overdue,icon:"clock",c:T.red,sub:"Need attention"},
                {l:"Reminders",v:reminders.length,icon:"mail",c:T.goldLight,sub:"All time"},
              ].map((s,i)=>(
                <div key={i} className="card" style={{padding:"16px"}}>
                  <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",marginBottom:12}}>
                    <span style={{fontSize:9,color:T.textMuted,letterSpacing:".4px",textTransform:"uppercase",fontWeight:700}}>{s.l}</span>
                    <Ic n={s.icon} s={13} c={s.c}/>
                  </div>
                  <div className="mono" style={{fontSize:"clamp(18px,3vw,24px)",fontWeight:500,color:s.c,marginBottom:2}}>{s.v}</div>
                  <div style={{fontSize:10,color:T.textMuted}}>{s.sub}</div>
                </div>
              ))}
            </div>
            <div className="card" style={{marginBottom:16}}>
              <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:16}}>
                <h2 style={{fontSize:15,fontWeight:700}}>Recent Invoices</h2>
                <button className="btn-primary" onClick={openAddInvoice} style={{padding:"7px 12px",fontSize:12}}><Ic n="plus" s={13}/>Add Invoice</button>
              </div>
              {loading?<div style={{display:"flex",justifyContent:"center",padding:"32px 0"}}><div className="spinner-gold"/></div>:
               invoices.length===0?<div style={{textAlign:"center",padding:"32px 0",color:T.textMuted}}><div style={{fontSize:32,marginBottom:10}}>📄</div><p style={{fontSize:14,marginBottom:16}}>No invoices yet. Add your first one!</p><button className="btn-primary" onClick={openAddInvoice}><Ic n="plus" s={14}/>Add First Invoice</button></div>:
               invoices.slice(0,5).map((inv,i)=>(
                <div key={inv.id} className="table-row" style={{display:"flex",alignItems:"center",gap:12,padding:"12px 6px",borderBottom:i<Math.min(invoices.length,5)-1?`1px solid ${T.border}`:"none"}}>
                  <div style={{width:34,height:34,borderRadius:9,background:T.surfaceEl,border:`1px solid ${T.border}`,display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0}}>
                    <span style={{fontSize:13,fontWeight:700,color:T.textSub}}>{inv.client_name[0]}</span>
                  </div>
                  <div style={{flex:1,minWidth:0}}>
                    <div style={{fontSize:13,fontWeight:700,color:T.text,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{inv.client_name}</div>
                    <div style={{fontSize:11,color:T.textMuted}}>{inv.project_name}</div>
                  </div>
                  <div className="mono" style={{fontSize:13,color:T.text,flexShrink:0}}>{fmt(inv.amount)}</div>
                  <span className={`badge badge-${inv.status==="overdue"?"red":inv.status==="paid"?"green":"amber"}`} style={{flexShrink:0}}>{inv.status}</span>
                  {inv.status!=="paid"&&(
                    <div style={{display:"flex",gap:5,flexShrink:0}}>
                      <button onClick={()=>sendReminder(inv,daysUntil(inv.due_date)>0?"preDue":daysUntil(inv.due_date)===0?"dueToday":"overdue")} className="btn-ghost" style={{padding:"5px 8px",fontSize:11}}><Ic n="mail" s={12}/></button>
                      <button onClick={()=>markPaid(inv)} className="btn-ghost" style={{padding:"5px 8px",fontSize:11,borderColor:"rgba(34,197,94,.3)",color:T.green}}><Ic n="check" s={12}/></button>
                    </div>
                  )}
                </div>
              ))}
            </div>
            <div className="card">
              <h2 style={{fontSize:15,fontWeight:700,marginBottom:18}}>Auto-Reminder Flow</h2>
              <div style={{display:"flex",alignItems:"flex-start"}}>
                {[{day:"3 days before",title:"Friendly Heads-Up",desc:"Warm reminder approaching.",c:T.goldLight},{day:"Due Date",title:"Final Notice",desc:"Payment is due today.",c:T.amber},{day:"5 days after",title:"Firm Follow-Up",desc:"Professional overdue.",c:T.red}].map((s,i)=>(
                  <div key={i} style={{flex:1,padding:"0 8px",textAlign:"center",borderRight:i<2?`1px solid ${T.border}`:"none"}}>
                    <div style={{width:26,height:26,borderRadius:"50%",border:`2px solid ${s.c}`,background:"rgba(0,0,0,.3)",display:"flex",alignItems:"center",justifyContent:"center",margin:"0 auto 8px"}}><Ic n="mail" s={11} c={s.c}/></div>
                    <span style={{fontSize:9,fontWeight:700,color:s.c,letterSpacing:".5px",textTransform:"uppercase"}}>{s.day}</span>
                    <div style={{fontSize:12,fontWeight:700,color:T.text,margin:"4px 0 2px"}}>{s.title}</div>
                    <div style={{fontSize:11,color:T.textMuted,lineHeight:1.5}}>{s.desc}</div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        )}

        {/* INVOICES */}
        {tab==="invoices"&&(
          <div className="fade-in">
            <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:22}}>
              <div><h1 style={{fontFamily:"Instrument Serif",fontSize:"clamp(24px,4vw,30px)",fontWeight:400,marginBottom:3}}>Invoices</h1><p style={{fontSize:13,color:T.textSub}}>{invoices.length} total · {invoices.filter(i=>i.status==="paid").length} paid</p></div>
              <button className="btn-primary" onClick={openAddInvoice} style={{padding:"9px 16px",fontSize:13}}><Ic n="plus" s={14}/>New</button>
            </div>
            {loading?<div style={{display:"flex",justifyContent:"center",padding:"60px 0"}}><div className="spinner-gold"/></div>:
             invoices.length===0?<div className="card" style={{textAlign:"center",padding:"48px 24px"}}><div style={{fontSize:40,marginBottom:14}}>📋</div><h3 style={{fontSize:18,fontWeight:700,marginBottom:8}}>No invoices yet</h3><p style={{color:T.textSub,marginBottom:20}}>Add your first invoice to start automated reminders</p><button className="btn-primary" onClick={openAddInvoice}><Ic n="plus" s={14}/>Add First Invoice</button></div>:(
              <>
                <div className="invoice-table card" style={{padding:0,overflow:"hidden"}}>
                  <div style={{display:"grid",gridTemplateColumns:"1.2fr 1fr 110px 110px 90px 160px",gap:12,padding:"12px 18px",borderBottom:`1px solid ${T.border}`}}>
                    {["Client","Project","Amount","Due Date","Status","Actions"].map((h,i)=><span key={i} style={{fontSize:10,color:T.textMuted,fontWeight:700,letterSpacing:".5px",textTransform:"uppercase"}}>{h}</span>)}
                  </div>
                  {invoices.map((inv,i)=>(
                    <div key={inv.id} className="table-row" style={{display:"grid",gridTemplateColumns:"1.2fr 1fr 110px 110px 90px 160px",gap:12,alignItems:"center",padding:"14px 18px",borderBottom:i<invoices.length-1?`1px solid ${T.border}`:"none"}}>
                      <div><div style={{fontSize:13,fontWeight:700,color:T.text}}>{inv.client_name}</div><div style={{fontSize:11,color:T.textMuted}}>{inv.client_email}</div></div>
                      <div style={{fontSize:13,color:T.textSub,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{inv.project_name}</div>
                      <div className="mono" style={{fontSize:13,color:T.text}}>{fmt(inv.amount)}</div>
                      <div style={{fontSize:12,color:T.textSub}}>{fmtDate(inv.due_date)}</div>
                      <span className={`badge badge-${inv.status==="overdue"?"red":inv.status==="paid"?"green":"amber"}`}>{inv.status}</span>
                      <div style={{display:"flex",gap:5}}>
                        {inv.status!=="paid"?<>
                          <button onClick={()=>sendReminder(inv,daysUntil(inv.due_date)>0?"preDue":daysUntil(inv.due_date)===0?"dueToday":"overdue")} className="btn-ghost" style={{padding:"5px 8px",fontSize:11}}><Ic n="mail" s={12}/></button>
                          <button onClick={()=>markPaid(inv)} className="btn-ghost" style={{padding:"5px 8px",fontSize:11,borderColor:"rgba(34,197,94,.3)",color:T.green}}><Ic n="check" s={12}/></button>
                          <button onClick={()=>deleteInvoice(inv.id)} className="btn-danger" style={{padding:"5px 8px",fontSize:11}}><Ic n="x" s={12}/></button>
                        </>:<span style={{fontSize:11,color:T.green,display:"flex",alignItems:"center",gap:4}}><Ic n="check" s={12} c={T.green}/>Collected</span>}
                      </div>
                    </div>
                  ))}
                </div>
                <div className="invoice-cards">
                  {invoices.map((inv,i)=>(
                    <div key={inv.id} className="card" style={{animationDelay:`${i*.04}s`}}>
                      <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",marginBottom:12}}>
                        <div><div style={{fontSize:14,fontWeight:700,color:T.text}}>{inv.client_name}</div><div style={{fontSize:12,color:T.textMuted}}>{inv.project_name}</div></div>
                        <span className={`badge badge-${inv.status==="overdue"?"red":inv.status==="paid"?"green":"amber"}`}>{inv.status}</span>
                      </div>
                      <div style={{display:"flex",justifyContent:"space-between",marginBottom:14}}>
                        <span className="mono" style={{fontSize:18,color:T.goldLight,fontWeight:500}}>{fmt(inv.amount)}</span>
                        <span style={{fontSize:12,color:T.textSub}}>Due {fmtDate(inv.due_date)}</span>
                      </div>
                      {inv.status!=="paid"&&<div style={{display:"flex",gap:8}}>
                        <button onClick={()=>sendReminder(inv,daysUntil(inv.due_date)>0?"preDue":daysUntil(inv.due_date)===0?"dueToday":"overdue")} className="btn-ghost" style={{flex:1,justifyContent:"center",fontSize:12}}><Ic n="mail" s={13}/>Remind</button>
                        <button onClick={()=>markPaid(inv)} className="btn-ghost" style={{flex:1,justifyContent:"center",fontSize:12,borderColor:"rgba(34,197,94,.3)",color:T.green}}><Ic n="check" s={13}/>Mark Paid</button>
                      </div>}
                    </div>
                  ))}
                </div>
              </>
            )}
          </div>
        )}

        {/* REMINDERS */}
        {tab==="reminders"&&(
          <div className="fade-in">
            <div style={{marginBottom:22}}><h1 style={{fontFamily:"Instrument Serif",fontSize:"clamp(24px,4vw,30px)",fontWeight:400,marginBottom:3}}>Reminder Log</h1><p style={{fontSize:13,color:T.textSub}}>Every automated email tracked</p></div>
            {reminders.length===0?<div className="card" style={{textAlign:"center",padding:"48px 24px"}}><div style={{fontSize:40,marginBottom:14}}>📬</div><h3 style={{fontSize:18,fontWeight:700,marginBottom:8}}>No reminders sent yet</h3><p style={{color:T.textSub}}>Add an invoice and send your first reminder</p></div>:(
              <div style={{display:"flex",flexDirection:"column",gap:10}}>
                {reminders.map((r,i)=>(
                  <div key={r.id} className="card" style={{display:"flex",alignItems:"center",gap:12,padding:"14px 16px"}}>
                    <div style={{width:36,height:36,borderRadius:10,background:`rgba(200,150,12,.08)`,border:`1px solid rgba(200,150,12,.15)`,display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0}}><Ic n="mail" s={15} c={T.goldLight}/></div>
                    <div style={{flex:1,minWidth:0}}>
                      <div style={{display:"flex",alignItems:"center",gap:7,marginBottom:2,flexWrap:"wrap"}}><span style={{fontSize:13,fontWeight:700,color:T.text}}>{r.invoices?.client_name||"Client"}</span><span className="badge badge-gold" style={{fontSize:8}}>{r.reminder_type}</span></div>
                      <div style={{fontSize:11,color:T.textMuted,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{r.email_subject}</div>
                    </div>
                    <span className={`badge badge-${r.status==="sent"?"green":"amber"}`} style={{flexShrink:0}}>{r.status}</span>
                  </div>
                ))}
              </div>
            )}
          </div>
        )}

        {/* ACCOUNT */}
        {tab==="account"&&(
          <div className="fade-in">
            <div style={{marginBottom:22}}><h1 style={{fontFamily:"Instrument Serif",fontSize:"clamp(24px,4vw,30px)",fontWeight:400,marginBottom:3}}>Account</h1><p style={{fontSize:13,color:T.textSub}}>Your profile and subscription</p></div>
            <div style={{display:"flex",flexDirection:"column",gap:16}}>
              <div className="card">
                <h2 style={{fontSize:15,fontWeight:700,marginBottom:16}}>Profile</h2>
                <div style={{display:"flex",flexDirection:"column",gap:12}}>
                  {[{l:"Full Name",v:profile?.full_name||"—"},{l:"Email Address",v:user.email},{l:"Phone Number",v:profile?.phone||"Not set"},{l:"Member Since",v:fmtDate(user.created_at)}].map((item,i)=>(
                    <div key={i}><label className="label">{item.l}</label><div className="input-field" style={{color:T.textSub}}>{item.v}</div></div>
                  ))}
                </div>
              </div>
              <div className="card">
                <h2 style={{fontSize:15,fontWeight:700,marginBottom:16}}>Subscription</h2>
                <div style={{background:T.surfaceEl,borderRadius:12,padding:"18px",marginBottom:16,border:`1px solid rgba(200,150,12,.15)`}}>
                  <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:6}}><span style={{fontSize:14,fontWeight:700,color:T.text}}>Free Trial</span><span className="badge badge-gold">ACTIVE</span></div>
                  <div style={{fontSize:12,color:T.textSub,marginBottom:14}}>30 days free · 3 invoices included</div>
                  <div style={{height:5,borderRadius:3,background:T.border,overflow:"hidden"}}><div style={{height:"100%",width:"30%",background:`linear-gradient(90deg,${T.gold},${T.goldLight})`,borderRadius:3}}/></div>
                  <div style={{fontSize:11,color:T.textMuted,marginTop:5}}>~21 days remaining</div>
                </div>
                <button className="btn-primary" style={{width:"100%",justifyContent:"center",padding:"12px"}}>Upgrade to Pro — ₹299/month</button>
              </div>
              <div className="card">
                <h2 style={{fontSize:15,fontWeight:700,marginBottom:6}}>Support</h2>
                <p style={{fontSize:13,color:T.textSub,marginBottom:14}}>Need help? Chat with us on WhatsApp — usually replies within 2 hours.</p>
                <a href={`https://wa.me/${WA_NUMBER}?text=Hi%2C%20I%20need%20help%20with%20ChaseNahi`} target="_blank" rel="noreferrer" style={{display:"inline-flex",alignItems:"center",gap:8,background:"rgba(34,197,94,.08)",border:"1px solid rgba(34,197,94,.2)",borderRadius:9,padding:"10px 16px",color:T.green,fontSize:13,fontWeight:700,textDecoration:"none"}}>
                  💬 Chat on WhatsApp
                </a>
              </div>
            </div>
          </div>
        )}
      </main>

      {showAdd&&<AddInvoiceModal user={user} profile={profile} onClose={()=>setShowAdd(false)} onSuccess={()=>{setShowAdd(false);loadInvoices();showToast("Invoice added! Reminders scheduled ✓");}}/>}
      {toast&&<Toast msg={toast.msg} type={toast.type} onClose={()=>setToast(null)}/>}
    </div>
  );
};

// ═══════════════════════════════════════════════════════════════════════════
// ROOT APP
// ═══════════════════════════════════════════════════════════════════════════
const LegalPage = ({type,onBack}) => {
  const isPrivacy = type === "privacy";

  return (
    <div style={{minHeight:"100vh",background:T.bg,color:T.text}}>
      <Noise/>

      <nav style={{
        position:"fixed",
        top:0,
        left:0,
        right:0,
        zIndex:100,
        background:"rgba(10,10,11,.92)",
        backdropFilter:"blur(20px)",
        borderBottom:`1px solid ${T.border}`
      }}>
        <div style={{
          maxWidth:900,
          margin:"0 auto",
          padding:"0 20px",
          height:60,
          display:"flex",
          alignItems:"center",
          justifyContent:"space-between"
        }}>
          <button
            onClick={onBack}
            className="btn-ghost"
            style={{padding:"8px 14px",fontSize:13}}
          >
            ← Back
          </button>

          <div style={{display:"flex",alignItems:"center",gap:8}}>
            <div style={{
              width:24,
              height:24,
              borderRadius:6,
              background:`linear-gradient(135deg,${T.gold},${T.goldLight})`,
              display:"flex",
              alignItems:"center",
              justifyContent:"center"
            }}>
              <Ic n="zap" s={12} c="#0A0A0B"/>
            </div>
            <span style={{fontFamily:"Instrument Serif",fontSize:18}}>ChaseNahi</span>
          </div>
        </div>
      </nav>

      <main style={{maxWidth:820,margin:"0 auto",padding:"100px 20px 60px"}}>
        <h1 style={{
          fontFamily:"Instrument Serif",
          fontSize:"clamp(34px,5vw,52px)",
          fontWeight:400,
          marginBottom:16
        }}>
          {isPrivacy ? "Privacy Policy" : "Terms & Conditions"}
        </h1>

        <p style={{color:T.textMuted,fontSize:13,marginBottom:32}}>
          Last updated: April 25, 2026
        </p>

        {isPrivacy ? (
          <div style={{color:T.textSub,lineHeight:1.9,fontSize:15}}>
            <p>ChaseNahi helps freelancers manage invoice reminders and payment follow-ups.</p>

            <h2 style={{color:T.text,marginTop:28,marginBottom:8}}>Information We Collect</h2>
            <p>We may collect your name, email address, phone number, client details, invoice amount, due dates, payment links, and reminder activity.</p>

            <h2 style={{color:T.text,marginTop:28,marginBottom:8}}>How We Use Your Data</h2>
            <p>We use this information to create invoices, send reminder emails, track invoice status, and improve the service.</p>

            <h2 style={{color:T.text,marginTop:28,marginBottom:8}}>Data Sharing</h2>
            <p>We do not sell your data. We may use trusted services like Supabase, Brevo, Vercel, and Razorpay to operate the platform.</p>

            <h2 style={{color:T.text,marginTop:28,marginBottom:8}}>Email Reminders</h2>
            <p>Reminder emails are sent only for invoice/payment communication entered by users. ChaseNahi is not intended for spam or bulk marketing.</p>

            <h2 style={{color:T.text,marginTop:28,marginBottom:8}}>Contact</h2>
            <p>For privacy-related questions, contact us at admin@chasenahi.in.</p>
          </div>
        ) : (
          <div style={{color:T.textSub,lineHeight:1.9,fontSize:15}}>
            <p>By using ChaseNahi, you agree to these terms.</p>

            <h2 style={{color:T.text,marginTop:28,marginBottom:8}}>Service Purpose</h2>
            <p>ChaseNahi provides invoice reminder and payment follow-up tools for freelancers and small businesses.</p>

            <h2 style={{color:T.text,marginTop:28,marginBottom:8}}>User Responsibility</h2>
            <p>You are responsible for ensuring that invoice details, client information, and payment links entered into the platform are accurate and legitimate.</p>

            <h2 style={{color:T.text,marginTop:28,marginBottom:8}}>No Guarantee of Payment</h2>
            <p>ChaseNahi helps automate reminders but does not guarantee that clients will pay invoices.</p>

            <h2 style={{color:T.text,marginTop:28,marginBottom:8}}>Prohibited Use</h2>
            <p>You may not use ChaseNahi for spam, fraud, harassment, illegal collections, or misleading payment requests.</p>

            <h2 style={{color:T.text,marginTop:28,marginBottom:8}}>Payments</h2>
            <p>Payment processing may be handled by third-party providers such as Razorpay. ChaseNahi does not directly hold client payment funds.</p>

            <h2 style={{color:T.text,marginTop:28,marginBottom:8}}>Contact</h2>
            <p>For support, contact us at admin@chasenahi.in.</p>
          </div>
        )}
      </main>
    </div>
  );
};
const ResetPassword = ({onSuccess}) => {
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [done, setDone] = useState(false);

  const submit = async () => {
    setError("");
    if (!password || password.length < 6) {
      setError("Password must be at least 6 characters.");
      return;
    }
    if (password !== confirm) {
      setError("Passwords do not match.");
      return;
    }
    setLoading(true);
    const { error: e } = await supabase.auth.updateUser({ password });
    setLoading(false);
    if (e) { setError(e.message); return; }
    setDone(true);
    setTimeout(() => onSuccess(), 2000);
  };

  return (
    <div style={{minHeight:"100vh",display:"flex",alignItems:"center",justifyContent:"center",padding:"20px",background:T.bg,position:"relative"}}>
      <Noise/>
      <div className="fade-up" style={{width:"100%",maxWidth:420}}>
        <div style={{display:"flex",alignItems:"center",gap:9,marginBottom:32}}>
          <div style={{width:34,height:34,borderRadius:9,background:`linear-gradient(135deg,${T.gold},${T.goldLight})`,display:"flex",alignItems:"center",justifyContent:"center"}}>
            <Ic n="zap" s={15} c="#0A0A0B"/>
          </div>
          <span style={{fontFamily:"Instrument Serif",fontSize:20}}>ChaseNahi</span>
        </div>
        {done ? (
          <div style={{background:"rgba(34,197,94,.08)",border:"1px solid rgba(34,197,94,.2)",borderRadius:12,padding:"28px",textAlign:"center"}}>
            <div style={{fontSize:40,marginBottom:12}}>✅</div>
            <h3 style={{fontSize:18,fontWeight:700,color:T.text,marginBottom:8}}>Password Updated!</h3>
            <p style={{fontSize:13,color:T.textSub}}>Redirecting you to dashboard...</p>
          </div>
        ) : (
          <>
            <h1 style={{fontFamily:"Instrument Serif",fontSize:32,fontWeight:400,marginBottom:6}}>Set New Password</h1>
            <p style={{fontSize:13,color:T.textSub,marginBottom:28}}>Enter your new password below.</p>
            <div style={{display:"flex",flexDirection:"column",gap:14}}>
              <div>
                <label className="label">New Password</label>
                <input className="input-field" type="password" placeholder="Min. 6 characters"
                  value={password} onChange={e=>setPassword(e.target.value)}/>
              </div>
              <div>
                <label className="label">Confirm Password</label>
                <input className="input-field" type="password" placeholder="Repeat password"
                  value={confirm} onChange={e=>setConfirm(e.target.value)}
                  onKeyDown={e=>e.key==="Enter"&&submit()}/>
              </div>
              {error&&(
                <div style={{background:"rgba(239,68,68,.08)",border:"1px solid rgba(239,68,68,.2)",borderRadius:8,padding:"10px 14px",fontSize:13,color:T.red}}>
                  {error}
                </div>
              )}
              <button className="btn-primary" onClick={submit} disabled={loading}
                style={{width:"100%",justifyContent:"center",padding:"13px",fontSize:14,marginTop:4}}>
                {loading?<><span className="spinner"/>Updating...</>:<>Update Password <Ic n="arrow" s={15}/></>}
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
};
export default function App() {
  const getPageFromPath = () => {
    const path = window.location.pathname;

    if (path === "/signup") return "signup";
    if (path === "/login") return "login";
    if (path === "/dashboard") return "dashboard";
    if (path === "/reset-password") return "reset-password";
    if (path === "/privacy") return "privacy";
    if (path === "/terms") return "terms";

    return "landing";
  };

  const [page,setPage] = useState(getPageFromPath());
  const [user,setUser] = useState(null);
  const [checking,setChecking] = useState(true);

  const goTo = (nextPage) => {
    const paths = {
      landing: "/",
      signup: "/signup",
      login: "/login",
      dashboard: "/dashboard",
      privacy: "/privacy",
      terms: "/terms",
      "reset-password": "/reset-password",
    };

    setPage(nextPage);
    window.history.pushState({page:nextPage},"",paths[nextPage] || "/");
    window.scrollTo(0,0);
  };

  useEffect(()=>{injectCSS();},[]);

  useEffect(()=>{
    const onPopState = () => {
  const path = window.location.pathname;

  if (path.startsWith("/blog/")) {
    setPage("landing");
    window.scrollTo(0, 0);
    return;
  }

  setPage(getPageFromPath());
  window.scrollTo(0,0);
};

    window.addEventListener("popstate",onPopState);
    return ()=>window.removeEventListener("popstate",onPopState);
  },[]);

  useEffect(()=>{
    const check = async () => {
  const {data:{session}} = await supabase.auth.getSession();

  if (session?.user){
    setUser(session.user);

    // If already on reset-password page, stay there
    if (window.location.pathname === "/reset-password") {
      setChecking(false);
      return;
    }

    if (window.location.pathname === "/" || window.location.pathname === "/login" || window.location.pathname === "/signup") {
      goTo("dashboard");
    }
  }
  setChecking(false);
};

    check();

    const {data:{subscription}} = supabase.auth.onAuthStateChange((event,session)=>{
      if (event === "PASSWORD_RECOVERY") {
  setUser(session.user);
  goTo("reset-password");
  return;
}
      if (session?.user){
        setUser(session.user);
        goTo("dashboard");
      } else {
        setUser(null);
        goTo("landing");
      }
    });

    return ()=>subscription.unsubscribe();
  },[]);

  const handleLogout = async () => {
    await supabase.auth.signOut();
    setUser(null);
    goTo("landing");
  };

  if (checking) return (
    <div style={{
      minHeight:"100vh",
      display:"flex",
      alignItems:"center",
      justifyContent:"center",
      background:T.bg
    }}>
      <div style={{
        display:"flex",
        flexDirection:"column",
        alignItems:"center",
        gap:16
      }}>
        <div style={{
          width:40,
          height:40,
          borderRadius:10,
          background:`linear-gradient(135deg,${T.gold},${T.goldLight})`,
          display:"flex",
          alignItems:"center",
          justifyContent:"center"
        }}>
          <Ic n="zap" s={18} c="#0A0A0B"/>
        </div>
        <div className="spinner-gold"/>
      </div>
    </div>
  );

  return (
    <>
      {page==="landing"&&(
        <Landing
          onSignup={()=>goTo("signup")}
          onLogin={()=>goTo("login")}
          onPrivacy={()=>goTo("privacy")}
          onTerms={()=>goTo("terms")}
        />
      )}

      {page==="signup"&&(
        <Auth
          mode="signup"
          onBack={()=>goTo("landing")}
          onSuccess={u=>{
            setUser(u);
            goTo("dashboard");
          }}
        />
      )}

      {page==="login"&&(
        <Auth
          mode="login"
          onBack={()=>goTo("landing")}
          onSuccess={u=>{
            setUser(u);
            goTo("dashboard");
          }}
        />
      )}

      {page==="privacy"&&(
        <LegalPage type="privacy" onBack={()=>goTo("landing")}/>
      )}
                     
    {page==="reset-password"&&(
  <ResetPassword onSuccess={()=>goTo("dashboard")}/>
)}
      {page==="terms"&&(
        <LegalPage type="terms" onBack={()=>goTo("landing")}/>
      )}

      {page==="dashboard"&&user&&(
        <Dashboard user={user} onLogout={handleLogout}/>
      )}
    </>
  );
}
